/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SystemviewRouteImport } from './routes/systemview'
import { Route as ReconstructionRouteImport } from './routes/reconstruction'
import { Route as OrganizationRouteImport } from './routes/organization'
import { Route as NiiDashboardRouteImport } from './routes/nii-dashboard'
import { Route as MigrationRouteImport } from './routes/migration'
import { Route as LibraRouteImport } from './routes/libra'
import { Route as LandingRouteImport } from './routes/landing'
import { Route as KestrelRouteImport } from './routes/kestrel'
import { Route as JobsRouteImport } from './routes/jobs'
import { Route as InventoryRouteImport } from './routes/inventory'
import { Route as HealthCheckRouteImport } from './routes/health-check'
import { Route as ValueStoriesRouteRouteImport } from './routes/value-stories.route'
import { Route as ShipsRouteRouteImport } from './routes/ships.route'
import { Route as PartsRouteRouteImport } from './routes/parts.route'
import { Route as InboxRouteRouteImport } from './routes/inbox/route'
import { Route as ExplorerRouteRouteImport } from './routes/explorer/route'
import { Route as AvailabilityPlanningRouteRouteImport } from './routes/availability-planning.route'
import { Route as ViewerIndexRouteImport } from './routes/viewer/index'
import { Route as NiiDashboardIndexRouteImport } from './routes/nii-dashboard.index'
import { Route as LibraIndexRouteImport } from './routes/libra.index'
import { Route as LibraDashboardIndexRouteImport } from './routes/libra-dashboard.index'
import { Route as KestrelIndexRouteImport } from './routes/kestrel.index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ExplorerIndexRouteImport } from './routes/explorer/index'
import { Route as Fallback_routeIndexRouteImport } from './routes/_fallback_route/index'
import { Route as WorkOrderWorkOrderIDRouteImport } from './routes/work-order.$workOrderID'
import { Route as WalkthroughChar123SiteIDChar125RouteImport } from './routes/walkthrough.{-$siteID}'
import { Route as WalkdownsChar123SiteIDChar125RouteImport } from './routes/walkdowns.{-$siteID}'
import { Route as UsersOrgIDRouteImport } from './routes/users.$orgID'
import { Route as SystemviewEntryIDRouteImport } from './routes/systemview.$entryID'
import { Route as SystemLensChar123SiteIDChar125RouteImport } from './routes/system-lens.{-$siteID}'
import { Route as SubAssemblySubAssemblyIDRouteImport } from './routes/sub-assembly.$subAssemblyID'
import { Route as ShipsSiteIDRouteImport } from './routes/ships.$siteID'
import { Route as SchedulingChar123SiteIDChar125RouteImport } from './routes/scheduling.{-$siteID}'
import { Route as PointCloudSiteIDRouteImport } from './routes/point-cloud.$siteID'
import { Route as OverviewChar123SiteIDChar125RouteImport } from './routes/overview.{-$siteID}'
import { Route as OrganizationOrgIDRouteImport } from './routes/organization.$orgID'
import { Route as NiiDashboardOrgIDRouteImport } from './routes/nii-dashboard.$orgID'
import { Route as MaximoChar123SiteIDChar125RouteImport } from './routes/maximo.{-$siteID}'
import { Route as LibraOrgIDRouteImport } from './routes/libra.$orgID'
import { Route as LibraDashboardOrgIDRouteImport } from './routes/libra-dashboard.$orgID'
import { Route as KestrelKestrelModelIdRouteImport } from './routes/kestrel.$kestrelModelId'
import { Route as JobSiteIDRouteImport } from './routes/job.$siteID'
import { Route as InspectionsChar123SiteIDChar125RouteImport } from './routes/inspections.{-$siteID}'
import { Route as InboxOrgOrSiteIDRouteImport } from './routes/inbox/$orgOrSiteID'
import { Route as ImportWizardSiteIDRouteImport } from './routes/import-wizard.$siteID'
import { Route as HomeChar123SiteIDChar125RouteImport } from './routes/home.{-$siteID}'
import { Route as HealthPlansChar123SiteIDChar125RouteImport } from './routes/health-plans.{-$siteID}'
import { Route as FlightDataUploadSiteIDRouteImport } from './routes/flightDataUpload.$siteID'
import { Route as FleetAnalysisSiteIDRouteImport } from './routes/fleet-analysis.$siteID'
import { Route as ExtensionsOrgIDRouteImport } from './routes/extensions.$orgID'
import { Route as ExplorerOrgOrSiteIDRouteImport } from './routes/explorer/$orgOrSiteID'
import { Route as EquipmentEquipmentIDRouteImport } from './routes/equipment.$equipmentID'
import { Route as DrilldownExplorationSiteIDRouteImport } from './routes/drilldown-exploration.$siteID'
import { Route as DocumentsSiteIDRouteImport } from './routes/documents.$siteID'
import { Route as DocumentUploadAssetIdRouteImport } from './routes/document-upload.$assetId'
import { Route as DetailsEntryIDRouteImport } from './routes/details/$entryID'
import { Route as BudgetingChar123SiteIDChar125RouteImport } from './routes/budgeting.{-$siteID}'
import { Route as AssemblyAssemblyIDRouteImport } from './routes/assembly.$assemblyID'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as WalkdownsSiteIDIndexRouteImport } from './routes/walkdowns.$siteID.index'
import { Route as VirtualReportsChar123SiteIDChar125IndexRouteImport } from './routes/virtual-reports.{-$siteID}.index'
import { Route as ViewerUnitIDIndexRouteImport } from './routes/viewer/$unitID/index'
import { Route as ValueStoriesSiteIDIndexRouteImport } from './routes/value-stories.$siteID.index'
import { Route as ShipsSiteIDIndexRouteImport } from './routes/ships.$siteID.index'
import { Route as ReportingChar123SiteIDChar125IndexRouteImport } from './routes/reporting.{-$siteID}.index'
import { Route as ProcessFlowsChar123SiteIDChar125IndexRouteImport } from './routes/process-flows.{-$siteID}.index'
import { Route as ProcessDataChar123SiteIDChar125IndexRouteImport } from './routes/process-data.{-$siteID}.index'
import { Route as PointCloudSiteIDIndexRouteImport } from './routes/point-cloud.$siteID.index'
import { Route as PartsSiteIDIndexRouteImport } from './routes/parts.$siteID.index'
import { Route as CasesChar123SiteIDChar125IndexRouteImport } from './routes/cases.{-$siteID}.index'
import { Route as AvailabilityPlanningSiteIDIndexRouteImport } from './routes/availability-planning.$siteID.index'
import { Route as AssetsChar123SiteIDChar125IndexRouteImport } from './routes/assets.{-$siteID}.index'
import { Route as AssetAssessmentSiteIDIndexRouteImport } from './routes/asset-assessment.$siteID.index'
import { Route as AnomalyDetectionSiteIDIndexRouteImport } from './routes/anomaly-detection.$siteID.index'
import { Route as AlertsChar123SiteIDChar125IndexRouteImport } from './routes/alerts.{-$siteID}.index'
import { Route as WalkdownsSiteIDWalkdownIdRouteImport } from './routes/walkdowns.$siteID.$walkdownId'
import { Route as VirtualReportsSiteIDComponentIDRouteImport } from './routes/virtual-reports.$siteID.$componentID'
import { Route as ViewerUnitIDInspectionRouteImport } from './routes/viewer/$unitID/inspection'
import { Route as ViewerUnitIDConfigurationRouteImport } from './routes/viewer/$unitID/configuration'
import { Route as ValueStoriesSiteIDAddRouteImport } from './routes/value-stories.$siteID.add'
import { Route as ReportingSiteIDNewRouteImport } from './routes/reporting.$siteID.new'
import { Route as ReportingSiteIDReportIDRouteImport } from './routes/reporting.$siteID.$reportID'
import { Route as ProcessFlowsSiteIDDiagramIDRouteImport } from './routes/process-flows.$siteID.$diagramID'
import { Route as ProcessDataSiteIDDashboardIDRouteImport } from './routes/process-data.$siteID.$dashboardID'
import { Route as PrismOrgIDEntryIdRouteImport } from './routes/prism.$orgID.$entryId'
import { Route as PointCloudSiteIDPointCloudOrSceneIDRouteImport } from './routes/point-cloud.$siteID.$pointCloudOrSceneID'
import { Route as OrganizationOrgIDSiteRouteImport } from './routes/organization_.$orgID.site'
import { Route as LibraOrgIDWorkflowIdRouteImport } from './routes/libra.$orgID.$workflowId'
import { Route as LibraDashboardOrgIDDashboardConfigIdRouteImport } from './routes/libra-dashboard.$orgID.$dashboardConfigId'
import { Route as CasesSiteIDCaseIDRouteImport } from './routes/cases.$siteID.$caseID'
import { Route as AssetsSiteIDUnitIDRouteImport } from './routes/assets.$siteID.$unitID'
import { Route as AssetLensSiteIDUnitIDRouteImport } from './routes/asset-lens.$siteID.$unitID'
import { Route as AssetAssessmentSiteIDUnitIDRouteImport } from './routes/asset-assessment.$siteID.$unitID'
import { Route as AnomalyDetectionSiteIDDetectionConfigurationIdRouteImport } from './routes/anomaly-detection.$siteID.$detectionConfigurationId'
import { Route as deprecated_page_namesSiteViewSiteIDRouteImport } from './routes/(deprecated_page_names)/site-view.$siteID'
import { Route as ValueStoriesSiteIDValueStoryIDIndexRouteImport } from './routes/value-stories.$siteID.$valueStoryID.index'
import { Route as ProductionDashboardOrgIDSiteIDIndexRouteImport } from './routes/production-dashboard.$orgID.$siteID.index'
import { Route as AvailabilityPlanningSiteIDShipIDIndexRouteImport } from './routes/availability-planning.$siteID.$shipID.index'
import { Route as ValueStoriesSiteIDValueStoryIDEditRouteImport } from './routes/value-stories.$siteID.$valueStoryID.edit'
import { Route as ProductionDashboardOrgIDSiteIDConfigIDRouteImport } from './routes/production-dashboard.$orgID.$siteID.$configID'
import { Route as OrganizationOrgIDSiteSiteIDRouteImport } from './routes/organization_.$orgID.site.$siteID'
import { Route as KestrelFormsInspectionTypeFormNameRouteImport } from './routes/kestrel.forms.$inspectionType.$formName'
import { Route as CasesSiteIDEditCaseIDRouteImport } from './routes/cases.$siteID.edit.$caseID'

const SystemviewRoute = SystemviewRouteImport.update({
  id: '/systemview',
  path: '/systemview',
  getParentRoute: () => rootRouteImport,
} as any)
const ReconstructionRoute = ReconstructionRouteImport.update({
  id: '/reconstruction',
  path: '/reconstruction',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationRoute = OrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => rootRouteImport,
} as any)
const NiiDashboardRoute = NiiDashboardRouteImport.update({
  id: '/nii-dashboard',
  path: '/nii-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const MigrationRoute = MigrationRouteImport.update({
  id: '/migration',
  path: '/migration',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraRoute = LibraRouteImport.update({
  id: '/libra',
  path: '/libra',
  getParentRoute: () => rootRouteImport,
} as any)
const LandingRoute = LandingRouteImport.update({
  id: '/landing',
  path: '/landing',
  getParentRoute: () => rootRouteImport,
} as any)
const KestrelRoute = KestrelRouteImport.update({
  id: '/kestrel',
  path: '/kestrel',
  getParentRoute: () => rootRouteImport,
} as any)
const JobsRoute = JobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => rootRouteImport,
} as any)
const InventoryRoute = InventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => rootRouteImport,
} as any)
const HealthCheckRoute = HealthCheckRouteImport.update({
  id: '/health-check',
  path: '/health-check',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesRouteRoute = ValueStoriesRouteRouteImport.update({
  id: '/value-stories',
  path: '/value-stories',
  getParentRoute: () => rootRouteImport,
} as any)
const ShipsRouteRoute = ShipsRouteRouteImport.update({
  id: '/ships',
  path: '/ships',
  getParentRoute: () => rootRouteImport,
} as any)
const PartsRouteRoute = PartsRouteRouteImport.update({
  id: '/parts',
  path: '/parts',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRouteRoute = InboxRouteRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorerRouteRoute = ExplorerRouteRouteImport.update({
  id: '/explorer',
  path: '/explorer',
  getParentRoute: () => rootRouteImport,
} as any)
const AvailabilityPlanningRouteRoute =
  AvailabilityPlanningRouteRouteImport.update({
    id: '/availability-planning',
    path: '/availability-planning',
    getParentRoute: () => rootRouteImport,
  } as any)
const ViewerIndexRoute = ViewerIndexRouteImport.update({
  id: '/viewer/',
  path: '/viewer/',
  getParentRoute: () => rootRouteImport,
} as any)
const NiiDashboardIndexRoute = NiiDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NiiDashboardRoute,
} as any)
const LibraIndexRoute = LibraIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraRoute,
} as any)
const LibraDashboardIndexRoute = LibraDashboardIndexRouteImport.update({
  id: '/libra-dashboard/',
  path: '/libra-dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const KestrelIndexRoute = KestrelIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KestrelRoute,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InboxRouteRoute,
} as any)
const ExplorerIndexRoute = ExplorerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ExplorerRouteRoute,
} as any)
const Fallback_routeIndexRoute = Fallback_routeIndexRouteImport.update({
  id: '/_fallback_route/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkOrderWorkOrderIDRoute = WorkOrderWorkOrderIDRouteImport.update({
  id: '/work-order/$workOrderID',
  path: '/work-order/$workOrderID',
  getParentRoute: () => rootRouteImport,
} as any)
const WalkthroughChar123SiteIDChar125Route =
  WalkthroughChar123SiteIDChar125RouteImport.update({
    id: '/walkthrough/{-$siteID}',
    path: '/walkthrough/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const WalkdownsChar123SiteIDChar125Route =
  WalkdownsChar123SiteIDChar125RouteImport.update({
    id: '/walkdowns/{-$siteID}',
    path: '/walkdowns/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const UsersOrgIDRoute = UsersOrgIDRouteImport.update({
  id: '/users/$orgID',
  path: '/users/$orgID',
  getParentRoute: () => rootRouteImport,
} as any)
const SystemviewEntryIDRoute = SystemviewEntryIDRouteImport.update({
  id: '/$entryID',
  path: '/$entryID',
  getParentRoute: () => SystemviewRoute,
} as any)
const SystemLensChar123SiteIDChar125Route =
  SystemLensChar123SiteIDChar125RouteImport.update({
    id: '/system-lens/{-$siteID}',
    path: '/system-lens/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const SubAssemblySubAssemblyIDRoute =
  SubAssemblySubAssemblyIDRouteImport.update({
    id: '/sub-assembly/$subAssemblyID',
    path: '/sub-assembly/$subAssemblyID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ShipsSiteIDRoute = ShipsSiteIDRouteImport.update({
  id: '/$siteID',
  path: '/$siteID',
  getParentRoute: () => ShipsRouteRoute,
} as any)
const SchedulingChar123SiteIDChar125Route =
  SchedulingChar123SiteIDChar125RouteImport.update({
    id: '/scheduling/{-$siteID}',
    path: '/scheduling/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const PointCloudSiteIDRoute = PointCloudSiteIDRouteImport.update({
  id: '/point-cloud/$siteID',
  path: '/point-cloud/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const OverviewChar123SiteIDChar125Route =
  OverviewChar123SiteIDChar125RouteImport.update({
    id: '/overview/{-$siteID}',
    path: '/overview/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationOrgIDRoute = OrganizationOrgIDRouteImport.update({
  id: '/$orgID',
  path: '/$orgID',
  getParentRoute: () => OrganizationRoute,
} as any)
const NiiDashboardOrgIDRoute = NiiDashboardOrgIDRouteImport.update({
  id: '/$orgID',
  path: '/$orgID',
  getParentRoute: () => NiiDashboardRoute,
} as any)
const MaximoChar123SiteIDChar125Route =
  MaximoChar123SiteIDChar125RouteImport.update({
    id: '/maximo/{-$siteID}',
    path: '/maximo/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const LibraOrgIDRoute = LibraOrgIDRouteImport.update({
  id: '/$orgID',
  path: '/$orgID',
  getParentRoute: () => LibraRoute,
} as any)
const LibraDashboardOrgIDRoute = LibraDashboardOrgIDRouteImport.update({
  id: '/libra-dashboard/$orgID',
  path: '/libra-dashboard/$orgID',
  getParentRoute: () => rootRouteImport,
} as any)
const KestrelKestrelModelIdRoute = KestrelKestrelModelIdRouteImport.update({
  id: '/$kestrelModelId',
  path: '/$kestrelModelId',
  getParentRoute: () => KestrelRoute,
} as any)
const JobSiteIDRoute = JobSiteIDRouteImport.update({
  id: '/job/$siteID',
  path: '/job/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const InspectionsChar123SiteIDChar125Route =
  InspectionsChar123SiteIDChar125RouteImport.update({
    id: '/inspections/{-$siteID}',
    path: '/inspections/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const InboxOrgOrSiteIDRoute = InboxOrgOrSiteIDRouteImport.update({
  id: '/$orgOrSiteID',
  path: '/$orgOrSiteID',
  getParentRoute: () => InboxRouteRoute,
} as any)
const ImportWizardSiteIDRoute = ImportWizardSiteIDRouteImport.update({
  id: '/import-wizard/$siteID',
  path: '/import-wizard/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeChar123SiteIDChar125Route =
  HomeChar123SiteIDChar125RouteImport.update({
    id: '/home/{-$siteID}',
    path: '/home/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const HealthPlansChar123SiteIDChar125Route =
  HealthPlansChar123SiteIDChar125RouteImport.update({
    id: '/health-plans/{-$siteID}',
    path: '/health-plans/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const FlightDataUploadSiteIDRoute = FlightDataUploadSiteIDRouteImport.update({
  id: '/flightDataUpload/$siteID',
  path: '/flightDataUpload/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const FleetAnalysisSiteIDRoute = FleetAnalysisSiteIDRouteImport.update({
  id: '/fleet-analysis/$siteID',
  path: '/fleet-analysis/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtensionsOrgIDRoute = ExtensionsOrgIDRouteImport.update({
  id: '/extensions/$orgID',
  path: '/extensions/$orgID',
  getParentRoute: () => rootRouteImport,
} as any)
const ExplorerOrgOrSiteIDRoute = ExplorerOrgOrSiteIDRouteImport.update({
  id: '/$orgOrSiteID',
  path: '/$orgOrSiteID',
  getParentRoute: () => ExplorerRouteRoute,
} as any)
const EquipmentEquipmentIDRoute = EquipmentEquipmentIDRouteImport.update({
  id: '/equipment/$equipmentID',
  path: '/equipment/$equipmentID',
  getParentRoute: () => rootRouteImport,
} as any)
const DrilldownExplorationSiteIDRoute =
  DrilldownExplorationSiteIDRouteImport.update({
    id: '/drilldown-exploration/$siteID',
    path: '/drilldown-exploration/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocumentsSiteIDRoute = DocumentsSiteIDRouteImport.update({
  id: '/documents/$siteID',
  path: '/documents/$siteID',
  getParentRoute: () => rootRouteImport,
} as any)
const DocumentUploadAssetIdRoute = DocumentUploadAssetIdRouteImport.update({
  id: '/document-upload/$assetId',
  path: '/document-upload/$assetId',
  getParentRoute: () => rootRouteImport,
} as any)
const DetailsEntryIDRoute = DetailsEntryIDRouteImport.update({
  id: '/details/$entryID',
  path: '/details/$entryID',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetingChar123SiteIDChar125Route =
  BudgetingChar123SiteIDChar125RouteImport.update({
    id: '/budgeting/{-$siteID}',
    path: '/budgeting/{-$siteID}',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssemblyAssemblyIDRoute = AssemblyAssemblyIDRouteImport.update({
  id: '/assembly/$assemblyID',
  path: '/assembly/$assemblyID',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const WalkdownsSiteIDIndexRoute = WalkdownsSiteIDIndexRouteImport.update({
  id: '/walkdowns/$siteID/',
  path: '/walkdowns/$siteID/',
  getParentRoute: () => rootRouteImport,
} as any)
const VirtualReportsChar123SiteIDChar125IndexRoute =
  VirtualReportsChar123SiteIDChar125IndexRouteImport.update({
    id: '/virtual-reports/{-$siteID}/',
    path: '/virtual-reports/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ViewerUnitIDIndexRoute = ViewerUnitIDIndexRouteImport.update({
  id: '/viewer/$unitID/',
  path: '/viewer/$unitID/',
  getParentRoute: () => rootRouteImport,
} as any)
const ValueStoriesSiteIDIndexRoute = ValueStoriesSiteIDIndexRouteImport.update({
  id: '/$siteID/',
  path: '/$siteID/',
  getParentRoute: () => ValueStoriesRouteRoute,
} as any)
const ShipsSiteIDIndexRoute = ShipsSiteIDIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ShipsSiteIDRoute,
} as any)
const ReportingChar123SiteIDChar125IndexRoute =
  ReportingChar123SiteIDChar125IndexRouteImport.update({
    id: '/reporting/{-$siteID}/',
    path: '/reporting/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessFlowsChar123SiteIDChar125IndexRoute =
  ProcessFlowsChar123SiteIDChar125IndexRouteImport.update({
    id: '/process-flows/{-$siteID}/',
    path: '/process-flows/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDataChar123SiteIDChar125IndexRoute =
  ProcessDataChar123SiteIDChar125IndexRouteImport.update({
    id: '/process-data/{-$siteID}/',
    path: '/process-data/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PointCloudSiteIDIndexRoute = PointCloudSiteIDIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PointCloudSiteIDRoute,
} as any)
const PartsSiteIDIndexRoute = PartsSiteIDIndexRouteImport.update({
  id: '/$siteID/',
  path: '/$siteID/',
  getParentRoute: () => PartsRouteRoute,
} as any)
const CasesChar123SiteIDChar125IndexRoute =
  CasesChar123SiteIDChar125IndexRouteImport.update({
    id: '/cases/{-$siteID}/',
    path: '/cases/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AvailabilityPlanningSiteIDIndexRoute =
  AvailabilityPlanningSiteIDIndexRouteImport.update({
    id: '/$siteID/',
    path: '/$siteID/',
    getParentRoute: () => AvailabilityPlanningRouteRoute,
  } as any)
const AssetsChar123SiteIDChar125IndexRoute =
  AssetsChar123SiteIDChar125IndexRouteImport.update({
    id: '/assets/{-$siteID}/',
    path: '/assets/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AssetAssessmentSiteIDIndexRoute =
  AssetAssessmentSiteIDIndexRouteImport.update({
    id: '/asset-assessment/$siteID/',
    path: '/asset-assessment/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnomalyDetectionSiteIDIndexRoute =
  AnomalyDetectionSiteIDIndexRouteImport.update({
    id: '/anomaly-detection/$siteID/',
    path: '/anomaly-detection/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AlertsChar123SiteIDChar125IndexRoute =
  AlertsChar123SiteIDChar125IndexRouteImport.update({
    id: '/alerts/{-$siteID}/',
    path: '/alerts/{-$siteID}/',
    getParentRoute: () => rootRouteImport,
  } as any)
const WalkdownsSiteIDWalkdownIdRoute =
  WalkdownsSiteIDWalkdownIdRouteImport.update({
    id: '/walkdowns/$siteID/$walkdownId',
    path: '/walkdowns/$siteID/$walkdownId',
    getParentRoute: () => rootRouteImport,
  } as any)
const VirtualReportsSiteIDComponentIDRoute =
  VirtualReportsSiteIDComponentIDRouteImport.update({
    id: '/virtual-reports/$siteID/$componentID',
    path: '/virtual-reports/$siteID/$componentID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ViewerUnitIDInspectionRoute = ViewerUnitIDInspectionRouteImport.update({
  id: '/viewer/$unitID/inspection',
  path: '/viewer/$unitID/inspection',
  getParentRoute: () => rootRouteImport,
} as any)
const ViewerUnitIDConfigurationRoute =
  ViewerUnitIDConfigurationRouteImport.update({
    id: '/viewer/$unitID/configuration',
    path: '/viewer/$unitID/configuration',
    getParentRoute: () => rootRouteImport,
  } as any)
const ValueStoriesSiteIDAddRoute = ValueStoriesSiteIDAddRouteImport.update({
  id: '/$siteID/add',
  path: '/$siteID/add',
  getParentRoute: () => ValueStoriesRouteRoute,
} as any)
const ReportingSiteIDNewRoute = ReportingSiteIDNewRouteImport.update({
  id: '/reporting/$siteID/new',
  path: '/reporting/$siteID/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingSiteIDReportIDRoute = ReportingSiteIDReportIDRouteImport.update({
  id: '/reporting/$siteID/$reportID',
  path: '/reporting/$siteID/$reportID',
  getParentRoute: () => rootRouteImport,
} as any)
const ProcessFlowsSiteIDDiagramIDRoute =
  ProcessFlowsSiteIDDiagramIDRouteImport.update({
    id: '/process-flows/$siteID/$diagramID',
    path: '/process-flows/$siteID/$diagramID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProcessDataSiteIDDashboardIDRoute =
  ProcessDataSiteIDDashboardIDRouteImport.update({
    id: '/process-data/$siteID/$dashboardID',
    path: '/process-data/$siteID/$dashboardID',
    getParentRoute: () => rootRouteImport,
  } as any)
const PrismOrgIDEntryIdRoute = PrismOrgIDEntryIdRouteImport.update({
  id: '/prism/$orgID/$entryId',
  path: '/prism/$orgID/$entryId',
  getParentRoute: () => rootRouteImport,
} as any)
const PointCloudSiteIDPointCloudOrSceneIDRoute =
  PointCloudSiteIDPointCloudOrSceneIDRouteImport.update({
    id: '/$pointCloudOrSceneID',
    path: '/$pointCloudOrSceneID',
    getParentRoute: () => PointCloudSiteIDRoute,
  } as any)
const OrganizationOrgIDSiteRoute = OrganizationOrgIDSiteRouteImport.update({
  id: '/organization_/$orgID/site',
  path: '/organization/$orgID/site',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraOrgIDWorkflowIdRoute = LibraOrgIDWorkflowIdRouteImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => LibraOrgIDRoute,
} as any)
const LibraDashboardOrgIDDashboardConfigIdRoute =
  LibraDashboardOrgIDDashboardConfigIdRouteImport.update({
    id: '/$dashboardConfigId',
    path: '/$dashboardConfigId',
    getParentRoute: () => LibraDashboardOrgIDRoute,
  } as any)
const CasesSiteIDCaseIDRoute = CasesSiteIDCaseIDRouteImport.update({
  id: '/cases/$siteID/$caseID',
  path: '/cases/$siteID/$caseID',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetsSiteIDUnitIDRoute = AssetsSiteIDUnitIDRouteImport.update({
  id: '/assets/$siteID/$unitID',
  path: '/assets/$siteID/$unitID',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetLensSiteIDUnitIDRoute = AssetLensSiteIDUnitIDRouteImport.update({
  id: '/asset-lens/$siteID/$unitID',
  path: '/asset-lens/$siteID/$unitID',
  getParentRoute: () => rootRouteImport,
} as any)
const AssetAssessmentSiteIDUnitIDRoute =
  AssetAssessmentSiteIDUnitIDRouteImport.update({
    id: '/asset-assessment/$siteID/$unitID',
    path: '/asset-assessment/$siteID/$unitID',
    getParentRoute: () => rootRouteImport,
  } as any)
const AnomalyDetectionSiteIDDetectionConfigurationIdRoute =
  AnomalyDetectionSiteIDDetectionConfigurationIdRouteImport.update({
    id: '/anomaly-detection/$siteID/$detectionConfigurationId',
    path: '/anomaly-detection/$siteID/$detectionConfigurationId',
    getParentRoute: () => rootRouteImport,
  } as any)
const deprecated_page_namesSiteViewSiteIDRoute =
  deprecated_page_namesSiteViewSiteIDRouteImport.update({
    id: '/(deprecated_page_names)/site-view/$siteID',
    path: '/site-view/$siteID',
    getParentRoute: () => rootRouteImport,
  } as any)
const ValueStoriesSiteIDValueStoryIDIndexRoute =
  ValueStoriesSiteIDValueStoryIDIndexRouteImport.update({
    id: '/$siteID/$valueStoryID/',
    path: '/$siteID/$valueStoryID/',
    getParentRoute: () => ValueStoriesRouteRoute,
  } as any)
const ProductionDashboardOrgIDSiteIDIndexRoute =
  ProductionDashboardOrgIDSiteIDIndexRouteImport.update({
    id: '/production-dashboard/$orgID/$siteID/',
    path: '/production-dashboard/$orgID/$siteID/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AvailabilityPlanningSiteIDShipIDIndexRoute =
  AvailabilityPlanningSiteIDShipIDIndexRouteImport.update({
    id: '/$siteID/$shipID/',
    path: '/$siteID/$shipID/',
    getParentRoute: () => AvailabilityPlanningRouteRoute,
  } as any)
const ValueStoriesSiteIDValueStoryIDEditRoute =
  ValueStoriesSiteIDValueStoryIDEditRouteImport.update({
    id: '/$siteID/$valueStoryID/edit',
    path: '/$siteID/$valueStoryID/edit',
    getParentRoute: () => ValueStoriesRouteRoute,
  } as any)
const ProductionDashboardOrgIDSiteIDConfigIDRoute =
  ProductionDashboardOrgIDSiteIDConfigIDRouteImport.update({
    id: '/production-dashboard/$orgID/$siteID/$configID',
    path: '/production-dashboard/$orgID/$siteID/$configID',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationOrgIDSiteSiteIDRoute =
  OrganizationOrgIDSiteSiteIDRouteImport.update({
    id: '/$siteID',
    path: '/$siteID',
    getParentRoute: () => OrganizationOrgIDSiteRoute,
  } as any)
const KestrelFormsInspectionTypeFormNameRoute =
  KestrelFormsInspectionTypeFormNameRouteImport.update({
    id: '/forms/$inspectionType/$formName',
    path: '/forms/$inspectionType/$formName',
    getParentRoute: () => KestrelRoute,
  } as any)
const CasesSiteIDEditCaseIDRoute = CasesSiteIDEditCaseIDRouteImport.update({
  id: '/cases/$siteID/edit/$caseID',
  path: '/cases/$siteID/edit/$caseID',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/availability-planning': typeof AvailabilityPlanningRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/ships': typeof ShipsRouteRouteWithChildren
  '/value-stories': typeof ValueStoriesRouteRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/kestrel': typeof KestrelRouteWithChildren
  '/landing': typeof LandingRoute
  '/libra': typeof LibraRouteWithChildren
  '/migration': typeof MigrationRoute
  '/nii-dashboard': typeof NiiDashboardRouteWithChildren
  '/organization': typeof OrganizationRouteWithChildren
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/budgeting/{-$siteID}': typeof BudgetingChar123SiteIDChar125Route
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/document-upload/$assetId': typeof DocumentUploadAssetIdRoute
  '/documents/$siteID': typeof DocumentsSiteIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/fleet-analysis/$siteID': typeof FleetAnalysisSiteIDRoute
  '/flightDataUpload/$siteID': typeof FlightDataUploadSiteIDRoute
  '/health-plans/{-$siteID}': typeof HealthPlansChar123SiteIDChar125Route
  '/home/{-$siteID}': typeof HomeChar123SiteIDChar125Route
  '/import-wizard/$siteID': typeof ImportWizardSiteIDRoute
  '/inbox/$orgOrSiteID': typeof InboxOrgOrSiteIDRoute
  '/inspections/{-$siteID}': typeof InspectionsChar123SiteIDChar125Route
  '/job/$siteID': typeof JobSiteIDRoute
  '/kestrel/$kestrelModelId': typeof KestrelKestrelModelIdRoute
  '/libra-dashboard/$orgID': typeof LibraDashboardOrgIDRouteWithChildren
  '/libra/$orgID': typeof LibraOrgIDRouteWithChildren
  '/maximo/{-$siteID}': typeof MaximoChar123SiteIDChar125Route
  '/nii-dashboard/$orgID': typeof NiiDashboardOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/{-$siteID}': typeof OverviewChar123SiteIDChar125Route
  '/point-cloud/$siteID': typeof PointCloudSiteIDRouteWithChildren
  '/scheduling/{-$siteID}': typeof SchedulingChar123SiteIDChar125Route
  '/ships/$siteID': typeof ShipsSiteIDRouteWithChildren
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/system-lens/{-$siteID}': typeof SystemLensChar123SiteIDChar125Route
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/walkdowns/{-$siteID}': typeof WalkdownsChar123SiteIDChar125Route
  '/walkthrough/{-$siteID}': typeof WalkthroughChar123SiteIDChar125Route
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/': typeof Fallback_routeIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/kestrel/': typeof KestrelIndexRoute
  '/libra-dashboard': typeof LibraDashboardIndexRoute
  '/libra/': typeof LibraIndexRoute
  '/nii-dashboard/': typeof NiiDashboardIndexRoute
  '/viewer': typeof ViewerIndexRoute
  '/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/anomaly-detection/$siteID/$detectionConfigurationId': typeof AnomalyDetectionSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/cases/$siteID/$caseID': typeof CasesSiteIDCaseIDRoute
  '/libra-dashboard/$orgID/$dashboardConfigId': typeof LibraDashboardOrgIDDashboardConfigIdRoute
  '/libra/$orgID/$workflowId': typeof LibraOrgIDWorkflowIdRoute
  '/organization/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/prism/$orgID/$entryId': typeof PrismOrgIDEntryIdRoute
  '/process-data/$siteID/$dashboardID': typeof ProcessDataSiteIDDashboardIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/reporting/$siteID/$reportID': typeof ReportingSiteIDReportIDRoute
  '/reporting/$siteID/new': typeof ReportingSiteIDNewRoute
  '/value-stories/$siteID/add': typeof ValueStoriesSiteIDAddRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/virtual-reports/$siteID/$componentID': typeof VirtualReportsSiteIDComponentIDRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/alerts/{-$siteID}': typeof AlertsChar123SiteIDChar125IndexRoute
  '/anomaly-detection/$siteID': typeof AnomalyDetectionSiteIDIndexRoute
  '/asset-assessment/$siteID': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/{-$siteID}': typeof AssetsChar123SiteIDChar125IndexRoute
  '/availability-planning/$siteID': typeof AvailabilityPlanningSiteIDIndexRoute
  '/cases/{-$siteID}': typeof CasesChar123SiteIDChar125IndexRoute
  '/parts/$siteID': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID/': typeof PointCloudSiteIDIndexRoute
  '/process-data/{-$siteID}': typeof ProcessDataChar123SiteIDChar125IndexRoute
  '/process-flows/{-$siteID}': typeof ProcessFlowsChar123SiteIDChar125IndexRoute
  '/reporting/{-$siteID}': typeof ReportingChar123SiteIDChar125IndexRoute
  '/ships/$siteID/': typeof ShipsSiteIDIndexRoute
  '/value-stories/$siteID': typeof ValueStoriesSiteIDIndexRoute
  '/viewer/$unitID': typeof ViewerUnitIDIndexRoute
  '/virtual-reports/{-$siteID}': typeof VirtualReportsChar123SiteIDChar125IndexRoute
  '/walkdowns/$siteID': typeof WalkdownsSiteIDIndexRoute
  '/cases/$siteID/edit/$caseID': typeof CasesSiteIDEditCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/organization/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
  '/production-dashboard/$orgID/$siteID/$configID': typeof ProductionDashboardOrgIDSiteIDConfigIDRoute
  '/value-stories/$siteID/$valueStoryID/edit': typeof ValueStoriesSiteIDValueStoryIDEditRoute
  '/availability-planning/$siteID/$shipID': typeof AvailabilityPlanningSiteIDShipIDIndexRoute
  '/production-dashboard/$orgID/$siteID': typeof ProductionDashboardOrgIDSiteIDIndexRoute
  '/value-stories/$siteID/$valueStoryID': typeof ValueStoriesSiteIDValueStoryIDIndexRoute
}
export interface FileRoutesByTo {
  '/availability-planning': typeof AvailabilityPlanningRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/ships': typeof ShipsRouteRouteWithChildren
  '/value-stories': typeof ValueStoriesRouteRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/landing': typeof LandingRoute
  '/migration': typeof MigrationRoute
  '/organization': typeof OrganizationRouteWithChildren
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/budgeting/{-$siteID}': typeof BudgetingChar123SiteIDChar125Route
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/document-upload/$assetId': typeof DocumentUploadAssetIdRoute
  '/documents/$siteID': typeof DocumentsSiteIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/fleet-analysis/$siteID': typeof FleetAnalysisSiteIDRoute
  '/flightDataUpload/$siteID': typeof FlightDataUploadSiteIDRoute
  '/health-plans/{-$siteID}': typeof HealthPlansChar123SiteIDChar125Route
  '/home/{-$siteID}': typeof HomeChar123SiteIDChar125Route
  '/import-wizard/$siteID': typeof ImportWizardSiteIDRoute
  '/inbox/$orgOrSiteID': typeof InboxOrgOrSiteIDRoute
  '/inspections/{-$siteID}': typeof InspectionsChar123SiteIDChar125Route
  '/job/$siteID': typeof JobSiteIDRoute
  '/kestrel/$kestrelModelId': typeof KestrelKestrelModelIdRoute
  '/libra-dashboard/$orgID': typeof LibraDashboardOrgIDRouteWithChildren
  '/libra/$orgID': typeof LibraOrgIDRouteWithChildren
  '/maximo/{-$siteID}': typeof MaximoChar123SiteIDChar125Route
  '/nii-dashboard/$orgID': typeof NiiDashboardOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/{-$siteID}': typeof OverviewChar123SiteIDChar125Route
  '/scheduling/{-$siteID}': typeof SchedulingChar123SiteIDChar125Route
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/system-lens/{-$siteID}': typeof SystemLensChar123SiteIDChar125Route
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/walkdowns/{-$siteID}': typeof WalkdownsChar123SiteIDChar125Route
  '/walkthrough/{-$siteID}': typeof WalkthroughChar123SiteIDChar125Route
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/': typeof Fallback_routeIndexRoute
  '/explorer': typeof ExplorerIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/kestrel': typeof KestrelIndexRoute
  '/libra-dashboard': typeof LibraDashboardIndexRoute
  '/libra': typeof LibraIndexRoute
  '/nii-dashboard': typeof NiiDashboardIndexRoute
  '/viewer': typeof ViewerIndexRoute
  '/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/anomaly-detection/$siteID/$detectionConfigurationId': typeof AnomalyDetectionSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/cases/$siteID/$caseID': typeof CasesSiteIDCaseIDRoute
  '/libra-dashboard/$orgID/$dashboardConfigId': typeof LibraDashboardOrgIDDashboardConfigIdRoute
  '/libra/$orgID/$workflowId': typeof LibraOrgIDWorkflowIdRoute
  '/organization/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/prism/$orgID/$entryId': typeof PrismOrgIDEntryIdRoute
  '/process-data/$siteID/$dashboardID': typeof ProcessDataSiteIDDashboardIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/reporting/$siteID/$reportID': typeof ReportingSiteIDReportIDRoute
  '/reporting/$siteID/new': typeof ReportingSiteIDNewRoute
  '/value-stories/$siteID/add': typeof ValueStoriesSiteIDAddRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/virtual-reports/$siteID/$componentID': typeof VirtualReportsSiteIDComponentIDRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/alerts/{-$siteID}': typeof AlertsChar123SiteIDChar125IndexRoute
  '/anomaly-detection/$siteID': typeof AnomalyDetectionSiteIDIndexRoute
  '/asset-assessment/$siteID': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/{-$siteID}': typeof AssetsChar123SiteIDChar125IndexRoute
  '/availability-planning/$siteID': typeof AvailabilityPlanningSiteIDIndexRoute
  '/cases/{-$siteID}': typeof CasesChar123SiteIDChar125IndexRoute
  '/parts/$siteID': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID': typeof PointCloudSiteIDIndexRoute
  '/process-data/{-$siteID}': typeof ProcessDataChar123SiteIDChar125IndexRoute
  '/process-flows/{-$siteID}': typeof ProcessFlowsChar123SiteIDChar125IndexRoute
  '/reporting/{-$siteID}': typeof ReportingChar123SiteIDChar125IndexRoute
  '/ships/$siteID': typeof ShipsSiteIDIndexRoute
  '/value-stories/$siteID': typeof ValueStoriesSiteIDIndexRoute
  '/viewer/$unitID': typeof ViewerUnitIDIndexRoute
  '/virtual-reports/{-$siteID}': typeof VirtualReportsChar123SiteIDChar125IndexRoute
  '/walkdowns/$siteID': typeof WalkdownsSiteIDIndexRoute
  '/cases/$siteID/edit/$caseID': typeof CasesSiteIDEditCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/organization/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
  '/production-dashboard/$orgID/$siteID/$configID': typeof ProductionDashboardOrgIDSiteIDConfigIDRoute
  '/value-stories/$siteID/$valueStoryID/edit': typeof ValueStoriesSiteIDValueStoryIDEditRoute
  '/availability-planning/$siteID/$shipID': typeof AvailabilityPlanningSiteIDShipIDIndexRoute
  '/production-dashboard/$orgID/$siteID': typeof ProductionDashboardOrgIDSiteIDIndexRoute
  '/value-stories/$siteID/$valueStoryID': typeof ValueStoriesSiteIDValueStoryIDIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/availability-planning': typeof AvailabilityPlanningRouteRouteWithChildren
  '/explorer': typeof ExplorerRouteRouteWithChildren
  '/inbox': typeof InboxRouteRouteWithChildren
  '/parts': typeof PartsRouteRouteWithChildren
  '/ships': typeof ShipsRouteRouteWithChildren
  '/value-stories': typeof ValueStoriesRouteRouteWithChildren
  '/health-check': typeof HealthCheckRoute
  '/inventory': typeof InventoryRoute
  '/jobs': typeof JobsRoute
  '/kestrel': typeof KestrelRouteWithChildren
  '/landing': typeof LandingRoute
  '/libra': typeof LibraRouteWithChildren
  '/migration': typeof MigrationRoute
  '/nii-dashboard': typeof NiiDashboardRouteWithChildren
  '/organization': typeof OrganizationRouteWithChildren
  '/reconstruction': typeof ReconstructionRoute
  '/systemview': typeof SystemviewRouteWithChildren
  '/admin/users': typeof AdminUsersRoute
  '/assembly/$assemblyID': typeof AssemblyAssemblyIDRoute
  '/budgeting/{-$siteID}': typeof BudgetingChar123SiteIDChar125Route
  '/details/$entryID': typeof DetailsEntryIDRoute
  '/document-upload/$assetId': typeof DocumentUploadAssetIdRoute
  '/documents/$siteID': typeof DocumentsSiteIDRoute
  '/drilldown-exploration/$siteID': typeof DrilldownExplorationSiteIDRoute
  '/equipment/$equipmentID': typeof EquipmentEquipmentIDRoute
  '/explorer/$orgOrSiteID': typeof ExplorerOrgOrSiteIDRoute
  '/extensions/$orgID': typeof ExtensionsOrgIDRoute
  '/fleet-analysis/$siteID': typeof FleetAnalysisSiteIDRoute
  '/flightDataUpload/$siteID': typeof FlightDataUploadSiteIDRoute
  '/health-plans/{-$siteID}': typeof HealthPlansChar123SiteIDChar125Route
  '/home/{-$siteID}': typeof HomeChar123SiteIDChar125Route
  '/import-wizard/$siteID': typeof ImportWizardSiteIDRoute
  '/inbox/$orgOrSiteID': typeof InboxOrgOrSiteIDRoute
  '/inspections/{-$siteID}': typeof InspectionsChar123SiteIDChar125Route
  '/job/$siteID': typeof JobSiteIDRoute
  '/kestrel/$kestrelModelId': typeof KestrelKestrelModelIdRoute
  '/libra-dashboard/$orgID': typeof LibraDashboardOrgIDRouteWithChildren
  '/libra/$orgID': typeof LibraOrgIDRouteWithChildren
  '/maximo/{-$siteID}': typeof MaximoChar123SiteIDChar125Route
  '/nii-dashboard/$orgID': typeof NiiDashboardOrgIDRoute
  '/organization/$orgID': typeof OrganizationOrgIDRoute
  '/overview/{-$siteID}': typeof OverviewChar123SiteIDChar125Route
  '/point-cloud/$siteID': typeof PointCloudSiteIDRouteWithChildren
  '/scheduling/{-$siteID}': typeof SchedulingChar123SiteIDChar125Route
  '/ships/$siteID': typeof ShipsSiteIDRouteWithChildren
  '/sub-assembly/$subAssemblyID': typeof SubAssemblySubAssemblyIDRoute
  '/system-lens/{-$siteID}': typeof SystemLensChar123SiteIDChar125Route
  '/systemview/$entryID': typeof SystemviewEntryIDRoute
  '/users/$orgID': typeof UsersOrgIDRoute
  '/walkdowns/{-$siteID}': typeof WalkdownsChar123SiteIDChar125Route
  '/walkthrough/{-$siteID}': typeof WalkthroughChar123SiteIDChar125Route
  '/work-order/$workOrderID': typeof WorkOrderWorkOrderIDRoute
  '/_fallback_route/': typeof Fallback_routeIndexRoute
  '/explorer/': typeof ExplorerIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/kestrel/': typeof KestrelIndexRoute
  '/libra-dashboard/': typeof LibraDashboardIndexRoute
  '/libra/': typeof LibraIndexRoute
  '/nii-dashboard/': typeof NiiDashboardIndexRoute
  '/viewer/': typeof ViewerIndexRoute
  '/(deprecated_page_names)/site-view/$siteID': typeof deprecated_page_namesSiteViewSiteIDRoute
  '/anomaly-detection/$siteID/$detectionConfigurationId': typeof AnomalyDetectionSiteIDDetectionConfigurationIdRoute
  '/asset-assessment/$siteID/$unitID': typeof AssetAssessmentSiteIDUnitIDRoute
  '/asset-lens/$siteID/$unitID': typeof AssetLensSiteIDUnitIDRoute
  '/assets/$siteID/$unitID': typeof AssetsSiteIDUnitIDRoute
  '/cases/$siteID/$caseID': typeof CasesSiteIDCaseIDRoute
  '/libra-dashboard/$orgID/$dashboardConfigId': typeof LibraDashboardOrgIDDashboardConfigIdRoute
  '/libra/$orgID/$workflowId': typeof LibraOrgIDWorkflowIdRoute
  '/organization_/$orgID/site': typeof OrganizationOrgIDSiteRouteWithChildren
  '/point-cloud/$siteID/$pointCloudOrSceneID': typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  '/prism/$orgID/$entryId': typeof PrismOrgIDEntryIdRoute
  '/process-data/$siteID/$dashboardID': typeof ProcessDataSiteIDDashboardIDRoute
  '/process-flows/$siteID/$diagramID': typeof ProcessFlowsSiteIDDiagramIDRoute
  '/reporting/$siteID/$reportID': typeof ReportingSiteIDReportIDRoute
  '/reporting/$siteID/new': typeof ReportingSiteIDNewRoute
  '/value-stories/$siteID/add': typeof ValueStoriesSiteIDAddRoute
  '/viewer/$unitID/configuration': typeof ViewerUnitIDConfigurationRoute
  '/viewer/$unitID/inspection': typeof ViewerUnitIDInspectionRoute
  '/virtual-reports/$siteID/$componentID': typeof VirtualReportsSiteIDComponentIDRoute
  '/walkdowns/$siteID/$walkdownId': typeof WalkdownsSiteIDWalkdownIdRoute
  '/alerts/{-$siteID}/': typeof AlertsChar123SiteIDChar125IndexRoute
  '/anomaly-detection/$siteID/': typeof AnomalyDetectionSiteIDIndexRoute
  '/asset-assessment/$siteID/': typeof AssetAssessmentSiteIDIndexRoute
  '/assets/{-$siteID}/': typeof AssetsChar123SiteIDChar125IndexRoute
  '/availability-planning/$siteID/': typeof AvailabilityPlanningSiteIDIndexRoute
  '/cases/{-$siteID}/': typeof CasesChar123SiteIDChar125IndexRoute
  '/parts/$siteID/': typeof PartsSiteIDIndexRoute
  '/point-cloud/$siteID/': typeof PointCloudSiteIDIndexRoute
  '/process-data/{-$siteID}/': typeof ProcessDataChar123SiteIDChar125IndexRoute
  '/process-flows/{-$siteID}/': typeof ProcessFlowsChar123SiteIDChar125IndexRoute
  '/reporting/{-$siteID}/': typeof ReportingChar123SiteIDChar125IndexRoute
  '/ships/$siteID/': typeof ShipsSiteIDIndexRoute
  '/value-stories/$siteID/': typeof ValueStoriesSiteIDIndexRoute
  '/viewer/$unitID/': typeof ViewerUnitIDIndexRoute
  '/virtual-reports/{-$siteID}/': typeof VirtualReportsChar123SiteIDChar125IndexRoute
  '/walkdowns/$siteID/': typeof WalkdownsSiteIDIndexRoute
  '/cases/$siteID/edit/$caseID': typeof CasesSiteIDEditCaseIDRoute
  '/kestrel/forms/$inspectionType/$formName': typeof KestrelFormsInspectionTypeFormNameRoute
  '/organization_/$orgID/site/$siteID': typeof OrganizationOrgIDSiteSiteIDRoute
  '/production-dashboard/$orgID/$siteID/$configID': typeof ProductionDashboardOrgIDSiteIDConfigIDRoute
  '/value-stories/$siteID/$valueStoryID/edit': typeof ValueStoriesSiteIDValueStoryIDEditRoute
  '/availability-planning/$siteID/$shipID/': typeof AvailabilityPlanningSiteIDShipIDIndexRoute
  '/production-dashboard/$orgID/$siteID/': typeof ProductionDashboardOrgIDSiteIDIndexRoute
  '/value-stories/$siteID/$valueStoryID/': typeof ValueStoriesSiteIDValueStoryIDIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/availability-planning'
    | '/explorer'
    | '/inbox'
    | '/parts'
    | '/ships'
    | '/value-stories'
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/kestrel'
    | '/landing'
    | '/libra'
    | '/migration'
    | '/nii-dashboard'
    | '/organization'
    | '/reconstruction'
    | '/systemview'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/budgeting/{-$siteID}'
    | '/details/$entryID'
    | '/document-upload/$assetId'
    | '/documents/$siteID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$orgOrSiteID'
    | '/extensions/$orgID'
    | '/fleet-analysis/$siteID'
    | '/flightDataUpload/$siteID'
    | '/health-plans/{-$siteID}'
    | '/home/{-$siteID}'
    | '/import-wizard/$siteID'
    | '/inbox/$orgOrSiteID'
    | '/inspections/{-$siteID}'
    | '/job/$siteID'
    | '/kestrel/$kestrelModelId'
    | '/libra-dashboard/$orgID'
    | '/libra/$orgID'
    | '/maximo/{-$siteID}'
    | '/nii-dashboard/$orgID'
    | '/organization/$orgID'
    | '/overview/{-$siteID}'
    | '/point-cloud/$siteID'
    | '/scheduling/{-$siteID}'
    | '/ships/$siteID'
    | '/sub-assembly/$subAssemblyID'
    | '/system-lens/{-$siteID}'
    | '/systemview/$entryID'
    | '/users/$orgID'
    | '/walkdowns/{-$siteID}'
    | '/walkthrough/{-$siteID}'
    | '/work-order/$workOrderID'
    | '/'
    | '/explorer/'
    | '/inbox/'
    | '/kestrel/'
    | '/libra-dashboard'
    | '/libra/'
    | '/nii-dashboard/'
    | '/viewer'
    | '/site-view/$siteID'
    | '/anomaly-detection/$siteID/$detectionConfigurationId'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/cases/$siteID/$caseID'
    | '/libra-dashboard/$orgID/$dashboardConfigId'
    | '/libra/$orgID/$workflowId'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/prism/$orgID/$entryId'
    | '/process-data/$siteID/$dashboardID'
    | '/process-flows/$siteID/$diagramID'
    | '/reporting/$siteID/$reportID'
    | '/reporting/$siteID/new'
    | '/value-stories/$siteID/add'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/virtual-reports/$siteID/$componentID'
    | '/walkdowns/$siteID/$walkdownId'
    | '/alerts/{-$siteID}'
    | '/anomaly-detection/$siteID'
    | '/asset-assessment/$siteID'
    | '/assets/{-$siteID}'
    | '/availability-planning/$siteID'
    | '/cases/{-$siteID}'
    | '/parts/$siteID'
    | '/point-cloud/$siteID/'
    | '/process-data/{-$siteID}'
    | '/process-flows/{-$siteID}'
    | '/reporting/{-$siteID}'
    | '/ships/$siteID/'
    | '/value-stories/$siteID'
    | '/viewer/$unitID'
    | '/virtual-reports/{-$siteID}'
    | '/walkdowns/$siteID'
    | '/cases/$siteID/edit/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/organization/$orgID/site/$siteID'
    | '/production-dashboard/$orgID/$siteID/$configID'
    | '/value-stories/$siteID/$valueStoryID/edit'
    | '/availability-planning/$siteID/$shipID'
    | '/production-dashboard/$orgID/$siteID'
    | '/value-stories/$siteID/$valueStoryID'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/availability-planning'
    | '/parts'
    | '/ships'
    | '/value-stories'
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/landing'
    | '/migration'
    | '/organization'
    | '/reconstruction'
    | '/systemview'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/budgeting/{-$siteID}'
    | '/details/$entryID'
    | '/document-upload/$assetId'
    | '/documents/$siteID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$orgOrSiteID'
    | '/extensions/$orgID'
    | '/fleet-analysis/$siteID'
    | '/flightDataUpload/$siteID'
    | '/health-plans/{-$siteID}'
    | '/home/{-$siteID}'
    | '/import-wizard/$siteID'
    | '/inbox/$orgOrSiteID'
    | '/inspections/{-$siteID}'
    | '/job/$siteID'
    | '/kestrel/$kestrelModelId'
    | '/libra-dashboard/$orgID'
    | '/libra/$orgID'
    | '/maximo/{-$siteID}'
    | '/nii-dashboard/$orgID'
    | '/organization/$orgID'
    | '/overview/{-$siteID}'
    | '/scheduling/{-$siteID}'
    | '/sub-assembly/$subAssemblyID'
    | '/system-lens/{-$siteID}'
    | '/systemview/$entryID'
    | '/users/$orgID'
    | '/walkdowns/{-$siteID}'
    | '/walkthrough/{-$siteID}'
    | '/work-order/$workOrderID'
    | '/'
    | '/explorer'
    | '/inbox'
    | '/kestrel'
    | '/libra-dashboard'
    | '/libra'
    | '/nii-dashboard'
    | '/viewer'
    | '/site-view/$siteID'
    | '/anomaly-detection/$siteID/$detectionConfigurationId'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/cases/$siteID/$caseID'
    | '/libra-dashboard/$orgID/$dashboardConfigId'
    | '/libra/$orgID/$workflowId'
    | '/organization/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/prism/$orgID/$entryId'
    | '/process-data/$siteID/$dashboardID'
    | '/process-flows/$siteID/$diagramID'
    | '/reporting/$siteID/$reportID'
    | '/reporting/$siteID/new'
    | '/value-stories/$siteID/add'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/virtual-reports/$siteID/$componentID'
    | '/walkdowns/$siteID/$walkdownId'
    | '/alerts/{-$siteID}'
    | '/anomaly-detection/$siteID'
    | '/asset-assessment/$siteID'
    | '/assets/{-$siteID}'
    | '/availability-planning/$siteID'
    | '/cases/{-$siteID}'
    | '/parts/$siteID'
    | '/point-cloud/$siteID'
    | '/process-data/{-$siteID}'
    | '/process-flows/{-$siteID}'
    | '/reporting/{-$siteID}'
    | '/ships/$siteID'
    | '/value-stories/$siteID'
    | '/viewer/$unitID'
    | '/virtual-reports/{-$siteID}'
    | '/walkdowns/$siteID'
    | '/cases/$siteID/edit/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/organization/$orgID/site/$siteID'
    | '/production-dashboard/$orgID/$siteID/$configID'
    | '/value-stories/$siteID/$valueStoryID/edit'
    | '/availability-planning/$siteID/$shipID'
    | '/production-dashboard/$orgID/$siteID'
    | '/value-stories/$siteID/$valueStoryID'
  id:
    | '__root__'
    | '/availability-planning'
    | '/explorer'
    | '/inbox'
    | '/parts'
    | '/ships'
    | '/value-stories'
    | '/health-check'
    | '/inventory'
    | '/jobs'
    | '/kestrel'
    | '/landing'
    | '/libra'
    | '/migration'
    | '/nii-dashboard'
    | '/organization'
    | '/reconstruction'
    | '/systemview'
    | '/admin/users'
    | '/assembly/$assemblyID'
    | '/budgeting/{-$siteID}'
    | '/details/$entryID'
    | '/document-upload/$assetId'
    | '/documents/$siteID'
    | '/drilldown-exploration/$siteID'
    | '/equipment/$equipmentID'
    | '/explorer/$orgOrSiteID'
    | '/extensions/$orgID'
    | '/fleet-analysis/$siteID'
    | '/flightDataUpload/$siteID'
    | '/health-plans/{-$siteID}'
    | '/home/{-$siteID}'
    | '/import-wizard/$siteID'
    | '/inbox/$orgOrSiteID'
    | '/inspections/{-$siteID}'
    | '/job/$siteID'
    | '/kestrel/$kestrelModelId'
    | '/libra-dashboard/$orgID'
    | '/libra/$orgID'
    | '/maximo/{-$siteID}'
    | '/nii-dashboard/$orgID'
    | '/organization/$orgID'
    | '/overview/{-$siteID}'
    | '/point-cloud/$siteID'
    | '/scheduling/{-$siteID}'
    | '/ships/$siteID'
    | '/sub-assembly/$subAssemblyID'
    | '/system-lens/{-$siteID}'
    | '/systemview/$entryID'
    | '/users/$orgID'
    | '/walkdowns/{-$siteID}'
    | '/walkthrough/{-$siteID}'
    | '/work-order/$workOrderID'
    | '/_fallback_route/'
    | '/explorer/'
    | '/inbox/'
    | '/kestrel/'
    | '/libra-dashboard/'
    | '/libra/'
    | '/nii-dashboard/'
    | '/viewer/'
    | '/(deprecated_page_names)/site-view/$siteID'
    | '/anomaly-detection/$siteID/$detectionConfigurationId'
    | '/asset-assessment/$siteID/$unitID'
    | '/asset-lens/$siteID/$unitID'
    | '/assets/$siteID/$unitID'
    | '/cases/$siteID/$caseID'
    | '/libra-dashboard/$orgID/$dashboardConfigId'
    | '/libra/$orgID/$workflowId'
    | '/organization_/$orgID/site'
    | '/point-cloud/$siteID/$pointCloudOrSceneID'
    | '/prism/$orgID/$entryId'
    | '/process-data/$siteID/$dashboardID'
    | '/process-flows/$siteID/$diagramID'
    | '/reporting/$siteID/$reportID'
    | '/reporting/$siteID/new'
    | '/value-stories/$siteID/add'
    | '/viewer/$unitID/configuration'
    | '/viewer/$unitID/inspection'
    | '/virtual-reports/$siteID/$componentID'
    | '/walkdowns/$siteID/$walkdownId'
    | '/alerts/{-$siteID}/'
    | '/anomaly-detection/$siteID/'
    | '/asset-assessment/$siteID/'
    | '/assets/{-$siteID}/'
    | '/availability-planning/$siteID/'
    | '/cases/{-$siteID}/'
    | '/parts/$siteID/'
    | '/point-cloud/$siteID/'
    | '/process-data/{-$siteID}/'
    | '/process-flows/{-$siteID}/'
    | '/reporting/{-$siteID}/'
    | '/ships/$siteID/'
    | '/value-stories/$siteID/'
    | '/viewer/$unitID/'
    | '/virtual-reports/{-$siteID}/'
    | '/walkdowns/$siteID/'
    | '/cases/$siteID/edit/$caseID'
    | '/kestrel/forms/$inspectionType/$formName'
    | '/organization_/$orgID/site/$siteID'
    | '/production-dashboard/$orgID/$siteID/$configID'
    | '/value-stories/$siteID/$valueStoryID/edit'
    | '/availability-planning/$siteID/$shipID/'
    | '/production-dashboard/$orgID/$siteID/'
    | '/value-stories/$siteID/$valueStoryID/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AvailabilityPlanningRouteRoute: typeof AvailabilityPlanningRouteRouteWithChildren
  ExplorerRouteRoute: typeof ExplorerRouteRouteWithChildren
  InboxRouteRoute: typeof InboxRouteRouteWithChildren
  PartsRouteRoute: typeof PartsRouteRouteWithChildren
  ShipsRouteRoute: typeof ShipsRouteRouteWithChildren
  ValueStoriesRouteRoute: typeof ValueStoriesRouteRouteWithChildren
  HealthCheckRoute: typeof HealthCheckRoute
  InventoryRoute: typeof InventoryRoute
  JobsRoute: typeof JobsRoute
  KestrelRoute: typeof KestrelRouteWithChildren
  LandingRoute: typeof LandingRoute
  LibraRoute: typeof LibraRouteWithChildren
  MigrationRoute: typeof MigrationRoute
  NiiDashboardRoute: typeof NiiDashboardRouteWithChildren
  OrganizationRoute: typeof OrganizationRouteWithChildren
  ReconstructionRoute: typeof ReconstructionRoute
  SystemviewRoute: typeof SystemviewRouteWithChildren
  AdminUsersRoute: typeof AdminUsersRoute
  AssemblyAssemblyIDRoute: typeof AssemblyAssemblyIDRoute
  BudgetingChar123SiteIDChar125Route: typeof BudgetingChar123SiteIDChar125Route
  DetailsEntryIDRoute: typeof DetailsEntryIDRoute
  DocumentUploadAssetIdRoute: typeof DocumentUploadAssetIdRoute
  DocumentsSiteIDRoute: typeof DocumentsSiteIDRoute
  DrilldownExplorationSiteIDRoute: typeof DrilldownExplorationSiteIDRoute
  EquipmentEquipmentIDRoute: typeof EquipmentEquipmentIDRoute
  ExtensionsOrgIDRoute: typeof ExtensionsOrgIDRoute
  FleetAnalysisSiteIDRoute: typeof FleetAnalysisSiteIDRoute
  FlightDataUploadSiteIDRoute: typeof FlightDataUploadSiteIDRoute
  HealthPlansChar123SiteIDChar125Route: typeof HealthPlansChar123SiteIDChar125Route
  HomeChar123SiteIDChar125Route: typeof HomeChar123SiteIDChar125Route
  ImportWizardSiteIDRoute: typeof ImportWizardSiteIDRoute
  InspectionsChar123SiteIDChar125Route: typeof InspectionsChar123SiteIDChar125Route
  JobSiteIDRoute: typeof JobSiteIDRoute
  LibraDashboardOrgIDRoute: typeof LibraDashboardOrgIDRouteWithChildren
  MaximoChar123SiteIDChar125Route: typeof MaximoChar123SiteIDChar125Route
  OverviewChar123SiteIDChar125Route: typeof OverviewChar123SiteIDChar125Route
  PointCloudSiteIDRoute: typeof PointCloudSiteIDRouteWithChildren
  SchedulingChar123SiteIDChar125Route: typeof SchedulingChar123SiteIDChar125Route
  SubAssemblySubAssemblyIDRoute: typeof SubAssemblySubAssemblyIDRoute
  SystemLensChar123SiteIDChar125Route: typeof SystemLensChar123SiteIDChar125Route
  UsersOrgIDRoute: typeof UsersOrgIDRoute
  WalkdownsChar123SiteIDChar125Route: typeof WalkdownsChar123SiteIDChar125Route
  WalkthroughChar123SiteIDChar125Route: typeof WalkthroughChar123SiteIDChar125Route
  WorkOrderWorkOrderIDRoute: typeof WorkOrderWorkOrderIDRoute
  Fallback_routeIndexRoute: typeof Fallback_routeIndexRoute
  LibraDashboardIndexRoute: typeof LibraDashboardIndexRoute
  ViewerIndexRoute: typeof ViewerIndexRoute
  deprecated_page_namesSiteViewSiteIDRoute: typeof deprecated_page_namesSiteViewSiteIDRoute
  AnomalyDetectionSiteIDDetectionConfigurationIdRoute: typeof AnomalyDetectionSiteIDDetectionConfigurationIdRoute
  AssetAssessmentSiteIDUnitIDRoute: typeof AssetAssessmentSiteIDUnitIDRoute
  AssetLensSiteIDUnitIDRoute: typeof AssetLensSiteIDUnitIDRoute
  AssetsSiteIDUnitIDRoute: typeof AssetsSiteIDUnitIDRoute
  CasesSiteIDCaseIDRoute: typeof CasesSiteIDCaseIDRoute
  OrganizationOrgIDSiteRoute: typeof OrganizationOrgIDSiteRouteWithChildren
  PrismOrgIDEntryIdRoute: typeof PrismOrgIDEntryIdRoute
  ProcessDataSiteIDDashboardIDRoute: typeof ProcessDataSiteIDDashboardIDRoute
  ProcessFlowsSiteIDDiagramIDRoute: typeof ProcessFlowsSiteIDDiagramIDRoute
  ReportingSiteIDReportIDRoute: typeof ReportingSiteIDReportIDRoute
  ReportingSiteIDNewRoute: typeof ReportingSiteIDNewRoute
  ViewerUnitIDConfigurationRoute: typeof ViewerUnitIDConfigurationRoute
  ViewerUnitIDInspectionRoute: typeof ViewerUnitIDInspectionRoute
  VirtualReportsSiteIDComponentIDRoute: typeof VirtualReportsSiteIDComponentIDRoute
  WalkdownsSiteIDWalkdownIdRoute: typeof WalkdownsSiteIDWalkdownIdRoute
  AlertsChar123SiteIDChar125IndexRoute: typeof AlertsChar123SiteIDChar125IndexRoute
  AnomalyDetectionSiteIDIndexRoute: typeof AnomalyDetectionSiteIDIndexRoute
  AssetAssessmentSiteIDIndexRoute: typeof AssetAssessmentSiteIDIndexRoute
  AssetsChar123SiteIDChar125IndexRoute: typeof AssetsChar123SiteIDChar125IndexRoute
  CasesChar123SiteIDChar125IndexRoute: typeof CasesChar123SiteIDChar125IndexRoute
  ProcessDataChar123SiteIDChar125IndexRoute: typeof ProcessDataChar123SiteIDChar125IndexRoute
  ProcessFlowsChar123SiteIDChar125IndexRoute: typeof ProcessFlowsChar123SiteIDChar125IndexRoute
  ReportingChar123SiteIDChar125IndexRoute: typeof ReportingChar123SiteIDChar125IndexRoute
  ViewerUnitIDIndexRoute: typeof ViewerUnitIDIndexRoute
  VirtualReportsChar123SiteIDChar125IndexRoute: typeof VirtualReportsChar123SiteIDChar125IndexRoute
  WalkdownsSiteIDIndexRoute: typeof WalkdownsSiteIDIndexRoute
  CasesSiteIDEditCaseIDRoute: typeof CasesSiteIDEditCaseIDRoute
  ProductionDashboardOrgIDSiteIDConfigIDRoute: typeof ProductionDashboardOrgIDSiteIDConfigIDRoute
  ProductionDashboardOrgIDSiteIDIndexRoute: typeof ProductionDashboardOrgIDSiteIDIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/systemview': {
      id: '/systemview'
      path: '/systemview'
      fullPath: '/systemview'
      preLoaderRoute: typeof SystemviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reconstruction': {
      id: '/reconstruction'
      path: '/reconstruction'
      fullPath: '/reconstruction'
      preLoaderRoute: typeof ReconstructionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization': {
      id: '/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof OrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nii-dashboard': {
      id: '/nii-dashboard'
      path: '/nii-dashboard'
      fullPath: '/nii-dashboard'
      preLoaderRoute: typeof NiiDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/migration': {
      id: '/migration'
      path: '/migration'
      fullPath: '/migration'
      preLoaderRoute: typeof MigrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra': {
      id: '/libra'
      path: '/libra'
      fullPath: '/libra'
      preLoaderRoute: typeof LibraRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/landing': {
      id: '/landing'
      path: '/landing'
      fullPath: '/landing'
      preLoaderRoute: typeof LandingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kestrel': {
      id: '/kestrel'
      path: '/kestrel'
      fullPath: '/kestrel'
      preLoaderRoute: typeof KestrelRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jobs': {
      id: '/jobs'
      path: '/jobs'
      fullPath: '/jobs'
      preLoaderRoute: typeof JobsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inventory': {
      id: '/inventory'
      path: '/inventory'
      fullPath: '/inventory'
      preLoaderRoute: typeof InventoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health-check': {
      id: '/health-check'
      path: '/health-check'
      fullPath: '/health-check'
      preLoaderRoute: typeof HealthCheckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories': {
      id: '/value-stories'
      path: '/value-stories'
      fullPath: '/value-stories'
      preLoaderRoute: typeof ValueStoriesRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ships': {
      id: '/ships'
      path: '/ships'
      fullPath: '/ships'
      preLoaderRoute: typeof ShipsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/parts': {
      id: '/parts'
      path: '/parts'
      fullPath: '/parts'
      preLoaderRoute: typeof PartsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer': {
      id: '/explorer'
      path: '/explorer'
      fullPath: '/explorer'
      preLoaderRoute: typeof ExplorerRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning': {
      id: '/availability-planning'
      path: '/availability-planning'
      fullPath: '/availability-planning'
      preLoaderRoute: typeof AvailabilityPlanningRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/': {
      id: '/viewer/'
      path: '/viewer'
      fullPath: '/viewer'
      preLoaderRoute: typeof ViewerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nii-dashboard/': {
      id: '/nii-dashboard/'
      path: '/'
      fullPath: '/nii-dashboard/'
      preLoaderRoute: typeof NiiDashboardIndexRouteImport
      parentRoute: typeof NiiDashboardRoute
    }
    '/libra/': {
      id: '/libra/'
      path: '/'
      fullPath: '/libra/'
      preLoaderRoute: typeof LibraIndexRouteImport
      parentRoute: typeof LibraRoute
    }
    '/libra-dashboard/': {
      id: '/libra-dashboard/'
      path: '/libra-dashboard'
      fullPath: '/libra-dashboard'
      preLoaderRoute: typeof LibraDashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kestrel/': {
      id: '/kestrel/'
      path: '/'
      fullPath: '/kestrel/'
      preLoaderRoute: typeof KestrelIndexRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof InboxRouteRoute
    }
    '/explorer/': {
      id: '/explorer/'
      path: '/'
      fullPath: '/explorer/'
      preLoaderRoute: typeof ExplorerIndexRouteImport
      parentRoute: typeof ExplorerRouteRoute
    }
    '/_fallback_route/': {
      id: '/_fallback_route/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof Fallback_routeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work-order/$workOrderID': {
      id: '/work-order/$workOrderID'
      path: '/work-order/$workOrderID'
      fullPath: '/work-order/$workOrderID'
      preLoaderRoute: typeof WorkOrderWorkOrderIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkthrough/{-$siteID}': {
      id: '/walkthrough/{-$siteID}'
      path: '/walkthrough/{-$siteID}'
      fullPath: '/walkthrough/{-$siteID}'
      preLoaderRoute: typeof WalkthroughChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/{-$siteID}': {
      id: '/walkdowns/{-$siteID}'
      path: '/walkdowns/{-$siteID}'
      fullPath: '/walkdowns/{-$siteID}'
      preLoaderRoute: typeof WalkdownsChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/$orgID': {
      id: '/users/$orgID'
      path: '/users/$orgID'
      fullPath: '/users/$orgID'
      preLoaderRoute: typeof UsersOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/systemview/$entryID': {
      id: '/systemview/$entryID'
      path: '/$entryID'
      fullPath: '/systemview/$entryID'
      preLoaderRoute: typeof SystemviewEntryIDRouteImport
      parentRoute: typeof SystemviewRoute
    }
    '/system-lens/{-$siteID}': {
      id: '/system-lens/{-$siteID}'
      path: '/system-lens/{-$siteID}'
      fullPath: '/system-lens/{-$siteID}'
      preLoaderRoute: typeof SystemLensChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sub-assembly/$subAssemblyID': {
      id: '/sub-assembly/$subAssemblyID'
      path: '/sub-assembly/$subAssemblyID'
      fullPath: '/sub-assembly/$subAssemblyID'
      preLoaderRoute: typeof SubAssemblySubAssemblyIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ships/$siteID': {
      id: '/ships/$siteID'
      path: '/$siteID'
      fullPath: '/ships/$siteID'
      preLoaderRoute: typeof ShipsSiteIDRouteImport
      parentRoute: typeof ShipsRouteRoute
    }
    '/scheduling/{-$siteID}': {
      id: '/scheduling/{-$siteID}'
      path: '/scheduling/{-$siteID}'
      fullPath: '/scheduling/{-$siteID}'
      preLoaderRoute: typeof SchedulingChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/$siteID': {
      id: '/point-cloud/$siteID'
      path: '/point-cloud/$siteID'
      fullPath: '/point-cloud/$siteID'
      preLoaderRoute: typeof PointCloudSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/overview/{-$siteID}': {
      id: '/overview/{-$siteID}'
      path: '/overview/{-$siteID}'
      fullPath: '/overview/{-$siteID}'
      preLoaderRoute: typeof OverviewChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization/$orgID': {
      id: '/organization/$orgID'
      path: '/$orgID'
      fullPath: '/organization/$orgID'
      preLoaderRoute: typeof OrganizationOrgIDRouteImport
      parentRoute: typeof OrganizationRoute
    }
    '/nii-dashboard/$orgID': {
      id: '/nii-dashboard/$orgID'
      path: '/$orgID'
      fullPath: '/nii-dashboard/$orgID'
      preLoaderRoute: typeof NiiDashboardOrgIDRouteImport
      parentRoute: typeof NiiDashboardRoute
    }
    '/maximo/{-$siteID}': {
      id: '/maximo/{-$siteID}'
      path: '/maximo/{-$siteID}'
      fullPath: '/maximo/{-$siteID}'
      preLoaderRoute: typeof MaximoChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra/$orgID': {
      id: '/libra/$orgID'
      path: '/$orgID'
      fullPath: '/libra/$orgID'
      preLoaderRoute: typeof LibraOrgIDRouteImport
      parentRoute: typeof LibraRoute
    }
    '/libra-dashboard/$orgID': {
      id: '/libra-dashboard/$orgID'
      path: '/libra-dashboard/$orgID'
      fullPath: '/libra-dashboard/$orgID'
      preLoaderRoute: typeof LibraDashboardOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kestrel/$kestrelModelId': {
      id: '/kestrel/$kestrelModelId'
      path: '/$kestrelModelId'
      fullPath: '/kestrel/$kestrelModelId'
      preLoaderRoute: typeof KestrelKestrelModelIdRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/job/$siteID': {
      id: '/job/$siteID'
      path: '/job/$siteID'
      fullPath: '/job/$siteID'
      preLoaderRoute: typeof JobSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inspections/{-$siteID}': {
      id: '/inspections/{-$siteID}'
      path: '/inspections/{-$siteID}'
      fullPath: '/inspections/{-$siteID}'
      preLoaderRoute: typeof InspectionsChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/$orgOrSiteID': {
      id: '/inbox/$orgOrSiteID'
      path: '/$orgOrSiteID'
      fullPath: '/inbox/$orgOrSiteID'
      preLoaderRoute: typeof InboxOrgOrSiteIDRouteImport
      parentRoute: typeof InboxRouteRoute
    }
    '/import-wizard/$siteID': {
      id: '/import-wizard/$siteID'
      path: '/import-wizard/$siteID'
      fullPath: '/import-wizard/$siteID'
      preLoaderRoute: typeof ImportWizardSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home/{-$siteID}': {
      id: '/home/{-$siteID}'
      path: '/home/{-$siteID}'
      fullPath: '/home/{-$siteID}'
      preLoaderRoute: typeof HomeChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/health-plans/{-$siteID}': {
      id: '/health-plans/{-$siteID}'
      path: '/health-plans/{-$siteID}'
      fullPath: '/health-plans/{-$siteID}'
      preLoaderRoute: typeof HealthPlansChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flightDataUpload/$siteID': {
      id: '/flightDataUpload/$siteID'
      path: '/flightDataUpload/$siteID'
      fullPath: '/flightDataUpload/$siteID'
      preLoaderRoute: typeof FlightDataUploadSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/fleet-analysis/$siteID': {
      id: '/fleet-analysis/$siteID'
      path: '/fleet-analysis/$siteID'
      fullPath: '/fleet-analysis/$siteID'
      preLoaderRoute: typeof FleetAnalysisSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extensions/$orgID': {
      id: '/extensions/$orgID'
      path: '/extensions/$orgID'
      fullPath: '/extensions/$orgID'
      preLoaderRoute: typeof ExtensionsOrgIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/explorer/$orgOrSiteID': {
      id: '/explorer/$orgOrSiteID'
      path: '/$orgOrSiteID'
      fullPath: '/explorer/$orgOrSiteID'
      preLoaderRoute: typeof ExplorerOrgOrSiteIDRouteImport
      parentRoute: typeof ExplorerRouteRoute
    }
    '/equipment/$equipmentID': {
      id: '/equipment/$equipmentID'
      path: '/equipment/$equipmentID'
      fullPath: '/equipment/$equipmentID'
      preLoaderRoute: typeof EquipmentEquipmentIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/drilldown-exploration/$siteID': {
      id: '/drilldown-exploration/$siteID'
      path: '/drilldown-exploration/$siteID'
      fullPath: '/drilldown-exploration/$siteID'
      preLoaderRoute: typeof DrilldownExplorationSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/documents/$siteID': {
      id: '/documents/$siteID'
      path: '/documents/$siteID'
      fullPath: '/documents/$siteID'
      preLoaderRoute: typeof DocumentsSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/document-upload/$assetId': {
      id: '/document-upload/$assetId'
      path: '/document-upload/$assetId'
      fullPath: '/document-upload/$assetId'
      preLoaderRoute: typeof DocumentUploadAssetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/details/$entryID': {
      id: '/details/$entryID'
      path: '/details/$entryID'
      fullPath: '/details/$entryID'
      preLoaderRoute: typeof DetailsEntryIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budgeting/{-$siteID}': {
      id: '/budgeting/{-$siteID}'
      path: '/budgeting/{-$siteID}'
      fullPath: '/budgeting/{-$siteID}'
      preLoaderRoute: typeof BudgetingChar123SiteIDChar125RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assembly/$assemblyID': {
      id: '/assembly/$assemblyID'
      path: '/assembly/$assemblyID'
      fullPath: '/assembly/$assemblyID'
      preLoaderRoute: typeof AssemblyAssemblyIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/$siteID/': {
      id: '/walkdowns/$siteID/'
      path: '/walkdowns/$siteID'
      fullPath: '/walkdowns/$siteID'
      preLoaderRoute: typeof WalkdownsSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/{-$siteID}/': {
      id: '/virtual-reports/{-$siteID}/'
      path: '/virtual-reports/{-$siteID}'
      fullPath: '/virtual-reports/{-$siteID}'
      preLoaderRoute: typeof VirtualReportsChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/': {
      id: '/viewer/$unitID/'
      path: '/viewer/$unitID'
      fullPath: '/viewer/$unitID'
      preLoaderRoute: typeof ViewerUnitIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/$siteID/': {
      id: '/value-stories/$siteID/'
      path: '/$siteID'
      fullPath: '/value-stories/$siteID'
      preLoaderRoute: typeof ValueStoriesSiteIDIndexRouteImport
      parentRoute: typeof ValueStoriesRouteRoute
    }
    '/ships/$siteID/': {
      id: '/ships/$siteID/'
      path: '/'
      fullPath: '/ships/$siteID/'
      preLoaderRoute: typeof ShipsSiteIDIndexRouteImport
      parentRoute: typeof ShipsSiteIDRoute
    }
    '/reporting/{-$siteID}/': {
      id: '/reporting/{-$siteID}/'
      path: '/reporting/{-$siteID}'
      fullPath: '/reporting/{-$siteID}'
      preLoaderRoute: typeof ReportingChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/{-$siteID}/': {
      id: '/process-flows/{-$siteID}/'
      path: '/process-flows/{-$siteID}'
      fullPath: '/process-flows/{-$siteID}'
      preLoaderRoute: typeof ProcessFlowsChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/{-$siteID}/': {
      id: '/process-data/{-$siteID}/'
      path: '/process-data/{-$siteID}'
      fullPath: '/process-data/{-$siteID}'
      preLoaderRoute: typeof ProcessDataChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/$siteID/': {
      id: '/point-cloud/$siteID/'
      path: '/'
      fullPath: '/point-cloud/$siteID/'
      preLoaderRoute: typeof PointCloudSiteIDIndexRouteImport
      parentRoute: typeof PointCloudSiteIDRoute
    }
    '/parts/$siteID/': {
      id: '/parts/$siteID/'
      path: '/$siteID'
      fullPath: '/parts/$siteID'
      preLoaderRoute: typeof PartsSiteIDIndexRouteImport
      parentRoute: typeof PartsRouteRoute
    }
    '/cases/{-$siteID}/': {
      id: '/cases/{-$siteID}/'
      path: '/cases/{-$siteID}'
      fullPath: '/cases/{-$siteID}'
      preLoaderRoute: typeof CasesChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning/$siteID/': {
      id: '/availability-planning/$siteID/'
      path: '/$siteID'
      fullPath: '/availability-planning/$siteID'
      preLoaderRoute: typeof AvailabilityPlanningSiteIDIndexRouteImport
      parentRoute: typeof AvailabilityPlanningRouteRoute
    }
    '/assets/{-$siteID}/': {
      id: '/assets/{-$siteID}/'
      path: '/assets/{-$siteID}'
      fullPath: '/assets/{-$siteID}'
      preLoaderRoute: typeof AssetsChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-assessment/$siteID/': {
      id: '/asset-assessment/$siteID/'
      path: '/asset-assessment/$siteID'
      fullPath: '/asset-assessment/$siteID'
      preLoaderRoute: typeof AssetAssessmentSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/$siteID/': {
      id: '/anomaly-detection/$siteID/'
      path: '/anomaly-detection/$siteID'
      fullPath: '/anomaly-detection/$siteID'
      preLoaderRoute: typeof AnomalyDetectionSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/alerts/{-$siteID}/': {
      id: '/alerts/{-$siteID}/'
      path: '/alerts/{-$siteID}'
      fullPath: '/alerts/{-$siteID}'
      preLoaderRoute: typeof AlertsChar123SiteIDChar125IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/walkdowns/$siteID/$walkdownId': {
      id: '/walkdowns/$siteID/$walkdownId'
      path: '/walkdowns/$siteID/$walkdownId'
      fullPath: '/walkdowns/$siteID/$walkdownId'
      preLoaderRoute: typeof WalkdownsSiteIDWalkdownIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/virtual-reports/$siteID/$componentID': {
      id: '/virtual-reports/$siteID/$componentID'
      path: '/virtual-reports/$siteID/$componentID'
      fullPath: '/virtual-reports/$siteID/$componentID'
      preLoaderRoute: typeof VirtualReportsSiteIDComponentIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/inspection': {
      id: '/viewer/$unitID/inspection'
      path: '/viewer/$unitID/inspection'
      fullPath: '/viewer/$unitID/inspection'
      preLoaderRoute: typeof ViewerUnitIDInspectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/viewer/$unitID/configuration': {
      id: '/viewer/$unitID/configuration'
      path: '/viewer/$unitID/configuration'
      fullPath: '/viewer/$unitID/configuration'
      preLoaderRoute: typeof ViewerUnitIDConfigurationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/$siteID/add': {
      id: '/value-stories/$siteID/add'
      path: '/$siteID/add'
      fullPath: '/value-stories/$siteID/add'
      preLoaderRoute: typeof ValueStoriesSiteIDAddRouteImport
      parentRoute: typeof ValueStoriesRouteRoute
    }
    '/reporting/$siteID/new': {
      id: '/reporting/$siteID/new'
      path: '/reporting/$siteID/new'
      fullPath: '/reporting/$siteID/new'
      preLoaderRoute: typeof ReportingSiteIDNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting/$siteID/$reportID': {
      id: '/reporting/$siteID/$reportID'
      path: '/reporting/$siteID/$reportID'
      fullPath: '/reporting/$siteID/$reportID'
      preLoaderRoute: typeof ReportingSiteIDReportIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-flows/$siteID/$diagramID': {
      id: '/process-flows/$siteID/$diagramID'
      path: '/process-flows/$siteID/$diagramID'
      fullPath: '/process-flows/$siteID/$diagramID'
      preLoaderRoute: typeof ProcessFlowsSiteIDDiagramIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/process-data/$siteID/$dashboardID': {
      id: '/process-data/$siteID/$dashboardID'
      path: '/process-data/$siteID/$dashboardID'
      fullPath: '/process-data/$siteID/$dashboardID'
      preLoaderRoute: typeof ProcessDataSiteIDDashboardIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/prism/$orgID/$entryId': {
      id: '/prism/$orgID/$entryId'
      path: '/prism/$orgID/$entryId'
      fullPath: '/prism/$orgID/$entryId'
      preLoaderRoute: typeof PrismOrgIDEntryIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/point-cloud/$siteID/$pointCloudOrSceneID': {
      id: '/point-cloud/$siteID/$pointCloudOrSceneID'
      path: '/$pointCloudOrSceneID'
      fullPath: '/point-cloud/$siteID/$pointCloudOrSceneID'
      preLoaderRoute: typeof PointCloudSiteIDPointCloudOrSceneIDRouteImport
      parentRoute: typeof PointCloudSiteIDRoute
    }
    '/organization_/$orgID/site': {
      id: '/organization_/$orgID/site'
      path: '/organization/$orgID/site'
      fullPath: '/organization/$orgID/site'
      preLoaderRoute: typeof OrganizationOrgIDSiteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/libra/$orgID/$workflowId': {
      id: '/libra/$orgID/$workflowId'
      path: '/$workflowId'
      fullPath: '/libra/$orgID/$workflowId'
      preLoaderRoute: typeof LibraOrgIDWorkflowIdRouteImport
      parentRoute: typeof LibraOrgIDRoute
    }
    '/libra-dashboard/$orgID/$dashboardConfigId': {
      id: '/libra-dashboard/$orgID/$dashboardConfigId'
      path: '/$dashboardConfigId'
      fullPath: '/libra-dashboard/$orgID/$dashboardConfigId'
      preLoaderRoute: typeof LibraDashboardOrgIDDashboardConfigIdRouteImport
      parentRoute: typeof LibraDashboardOrgIDRoute
    }
    '/cases/$siteID/$caseID': {
      id: '/cases/$siteID/$caseID'
      path: '/cases/$siteID/$caseID'
      fullPath: '/cases/$siteID/$caseID'
      preLoaderRoute: typeof CasesSiteIDCaseIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assets/$siteID/$unitID': {
      id: '/assets/$siteID/$unitID'
      path: '/assets/$siteID/$unitID'
      fullPath: '/assets/$siteID/$unitID'
      preLoaderRoute: typeof AssetsSiteIDUnitIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-lens/$siteID/$unitID': {
      id: '/asset-lens/$siteID/$unitID'
      path: '/asset-lens/$siteID/$unitID'
      fullPath: '/asset-lens/$siteID/$unitID'
      preLoaderRoute: typeof AssetLensSiteIDUnitIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/asset-assessment/$siteID/$unitID': {
      id: '/asset-assessment/$siteID/$unitID'
      path: '/asset-assessment/$siteID/$unitID'
      fullPath: '/asset-assessment/$siteID/$unitID'
      preLoaderRoute: typeof AssetAssessmentSiteIDUnitIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anomaly-detection/$siteID/$detectionConfigurationId': {
      id: '/anomaly-detection/$siteID/$detectionConfigurationId'
      path: '/anomaly-detection/$siteID/$detectionConfigurationId'
      fullPath: '/anomaly-detection/$siteID/$detectionConfigurationId'
      preLoaderRoute: typeof AnomalyDetectionSiteIDDetectionConfigurationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(deprecated_page_names)/site-view/$siteID': {
      id: '/(deprecated_page_names)/site-view/$siteID'
      path: '/site-view/$siteID'
      fullPath: '/site-view/$siteID'
      preLoaderRoute: typeof deprecated_page_namesSiteViewSiteIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/value-stories/$siteID/$valueStoryID/': {
      id: '/value-stories/$siteID/$valueStoryID/'
      path: '/$siteID/$valueStoryID'
      fullPath: '/value-stories/$siteID/$valueStoryID'
      preLoaderRoute: typeof ValueStoriesSiteIDValueStoryIDIndexRouteImport
      parentRoute: typeof ValueStoriesRouteRoute
    }
    '/production-dashboard/$orgID/$siteID/': {
      id: '/production-dashboard/$orgID/$siteID/'
      path: '/production-dashboard/$orgID/$siteID'
      fullPath: '/production-dashboard/$orgID/$siteID'
      preLoaderRoute: typeof ProductionDashboardOrgIDSiteIDIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/availability-planning/$siteID/$shipID/': {
      id: '/availability-planning/$siteID/$shipID/'
      path: '/$siteID/$shipID'
      fullPath: '/availability-planning/$siteID/$shipID'
      preLoaderRoute: typeof AvailabilityPlanningSiteIDShipIDIndexRouteImport
      parentRoute: typeof AvailabilityPlanningRouteRoute
    }
    '/value-stories/$siteID/$valueStoryID/edit': {
      id: '/value-stories/$siteID/$valueStoryID/edit'
      path: '/$siteID/$valueStoryID/edit'
      fullPath: '/value-stories/$siteID/$valueStoryID/edit'
      preLoaderRoute: typeof ValueStoriesSiteIDValueStoryIDEditRouteImport
      parentRoute: typeof ValueStoriesRouteRoute
    }
    '/production-dashboard/$orgID/$siteID/$configID': {
      id: '/production-dashboard/$orgID/$siteID/$configID'
      path: '/production-dashboard/$orgID/$siteID/$configID'
      fullPath: '/production-dashboard/$orgID/$siteID/$configID'
      preLoaderRoute: typeof ProductionDashboardOrgIDSiteIDConfigIDRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organization_/$orgID/site/$siteID': {
      id: '/organization_/$orgID/site/$siteID'
      path: '/$siteID'
      fullPath: '/organization/$orgID/site/$siteID'
      preLoaderRoute: typeof OrganizationOrgIDSiteSiteIDRouteImport
      parentRoute: typeof OrganizationOrgIDSiteRoute
    }
    '/kestrel/forms/$inspectionType/$formName': {
      id: '/kestrel/forms/$inspectionType/$formName'
      path: '/forms/$inspectionType/$formName'
      fullPath: '/kestrel/forms/$inspectionType/$formName'
      preLoaderRoute: typeof KestrelFormsInspectionTypeFormNameRouteImport
      parentRoute: typeof KestrelRoute
    }
    '/cases/$siteID/edit/$caseID': {
      id: '/cases/$siteID/edit/$caseID'
      path: '/cases/$siteID/edit/$caseID'
      fullPath: '/cases/$siteID/edit/$caseID'
      preLoaderRoute: typeof CasesSiteIDEditCaseIDRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AvailabilityPlanningRouteRouteChildren {
  AvailabilityPlanningSiteIDIndexRoute: typeof AvailabilityPlanningSiteIDIndexRoute
  AvailabilityPlanningSiteIDShipIDIndexRoute: typeof AvailabilityPlanningSiteIDShipIDIndexRoute
}

const AvailabilityPlanningRouteRouteChildren: AvailabilityPlanningRouteRouteChildren =
  {
    AvailabilityPlanningSiteIDIndexRoute: AvailabilityPlanningSiteIDIndexRoute,
    AvailabilityPlanningSiteIDShipIDIndexRoute:
      AvailabilityPlanningSiteIDShipIDIndexRoute,
  }

const AvailabilityPlanningRouteRouteWithChildren =
  AvailabilityPlanningRouteRoute._addFileChildren(
    AvailabilityPlanningRouteRouteChildren,
  )

interface ExplorerRouteRouteChildren {
  ExplorerOrgOrSiteIDRoute: typeof ExplorerOrgOrSiteIDRoute
  ExplorerIndexRoute: typeof ExplorerIndexRoute
}

const ExplorerRouteRouteChildren: ExplorerRouteRouteChildren = {
  ExplorerOrgOrSiteIDRoute: ExplorerOrgOrSiteIDRoute,
  ExplorerIndexRoute: ExplorerIndexRoute,
}

const ExplorerRouteRouteWithChildren = ExplorerRouteRoute._addFileChildren(
  ExplorerRouteRouteChildren,
)

interface InboxRouteRouteChildren {
  InboxOrgOrSiteIDRoute: typeof InboxOrgOrSiteIDRoute
  InboxIndexRoute: typeof InboxIndexRoute
}

const InboxRouteRouteChildren: InboxRouteRouteChildren = {
  InboxOrgOrSiteIDRoute: InboxOrgOrSiteIDRoute,
  InboxIndexRoute: InboxIndexRoute,
}

const InboxRouteRouteWithChildren = InboxRouteRoute._addFileChildren(
  InboxRouteRouteChildren,
)

interface PartsRouteRouteChildren {
  PartsSiteIDIndexRoute: typeof PartsSiteIDIndexRoute
}

const PartsRouteRouteChildren: PartsRouteRouteChildren = {
  PartsSiteIDIndexRoute: PartsSiteIDIndexRoute,
}

const PartsRouteRouteWithChildren = PartsRouteRoute._addFileChildren(
  PartsRouteRouteChildren,
)

interface ShipsSiteIDRouteChildren {
  ShipsSiteIDIndexRoute: typeof ShipsSiteIDIndexRoute
}

const ShipsSiteIDRouteChildren: ShipsSiteIDRouteChildren = {
  ShipsSiteIDIndexRoute: ShipsSiteIDIndexRoute,
}

const ShipsSiteIDRouteWithChildren = ShipsSiteIDRoute._addFileChildren(
  ShipsSiteIDRouteChildren,
)

interface ShipsRouteRouteChildren {
  ShipsSiteIDRoute: typeof ShipsSiteIDRouteWithChildren
}

const ShipsRouteRouteChildren: ShipsRouteRouteChildren = {
  ShipsSiteIDRoute: ShipsSiteIDRouteWithChildren,
}

const ShipsRouteRouteWithChildren = ShipsRouteRoute._addFileChildren(
  ShipsRouteRouteChildren,
)

interface ValueStoriesRouteRouteChildren {
  ValueStoriesSiteIDAddRoute: typeof ValueStoriesSiteIDAddRoute
  ValueStoriesSiteIDIndexRoute: typeof ValueStoriesSiteIDIndexRoute
  ValueStoriesSiteIDValueStoryIDEditRoute: typeof ValueStoriesSiteIDValueStoryIDEditRoute
  ValueStoriesSiteIDValueStoryIDIndexRoute: typeof ValueStoriesSiteIDValueStoryIDIndexRoute
}

const ValueStoriesRouteRouteChildren: ValueStoriesRouteRouteChildren = {
  ValueStoriesSiteIDAddRoute: ValueStoriesSiteIDAddRoute,
  ValueStoriesSiteIDIndexRoute: ValueStoriesSiteIDIndexRoute,
  ValueStoriesSiteIDValueStoryIDEditRoute:
    ValueStoriesSiteIDValueStoryIDEditRoute,
  ValueStoriesSiteIDValueStoryIDIndexRoute:
    ValueStoriesSiteIDValueStoryIDIndexRoute,
}

const ValueStoriesRouteRouteWithChildren =
  ValueStoriesRouteRoute._addFileChildren(ValueStoriesRouteRouteChildren)

interface KestrelRouteChildren {
  KestrelKestrelModelIdRoute: typeof KestrelKestrelModelIdRoute
  KestrelIndexRoute: typeof KestrelIndexRoute
  KestrelFormsInspectionTypeFormNameRoute: typeof KestrelFormsInspectionTypeFormNameRoute
}

const KestrelRouteChildren: KestrelRouteChildren = {
  KestrelKestrelModelIdRoute: KestrelKestrelModelIdRoute,
  KestrelIndexRoute: KestrelIndexRoute,
  KestrelFormsInspectionTypeFormNameRoute:
    KestrelFormsInspectionTypeFormNameRoute,
}

const KestrelRouteWithChildren =
  KestrelRoute._addFileChildren(KestrelRouteChildren)

interface LibraOrgIDRouteChildren {
  LibraOrgIDWorkflowIdRoute: typeof LibraOrgIDWorkflowIdRoute
}

const LibraOrgIDRouteChildren: LibraOrgIDRouteChildren = {
  LibraOrgIDWorkflowIdRoute: LibraOrgIDWorkflowIdRoute,
}

const LibraOrgIDRouteWithChildren = LibraOrgIDRoute._addFileChildren(
  LibraOrgIDRouteChildren,
)

interface LibraRouteChildren {
  LibraOrgIDRoute: typeof LibraOrgIDRouteWithChildren
  LibraIndexRoute: typeof LibraIndexRoute
}

const LibraRouteChildren: LibraRouteChildren = {
  LibraOrgIDRoute: LibraOrgIDRouteWithChildren,
  LibraIndexRoute: LibraIndexRoute,
}

const LibraRouteWithChildren = LibraRoute._addFileChildren(LibraRouteChildren)

interface NiiDashboardRouteChildren {
  NiiDashboardOrgIDRoute: typeof NiiDashboardOrgIDRoute
  NiiDashboardIndexRoute: typeof NiiDashboardIndexRoute
}

const NiiDashboardRouteChildren: NiiDashboardRouteChildren = {
  NiiDashboardOrgIDRoute: NiiDashboardOrgIDRoute,
  NiiDashboardIndexRoute: NiiDashboardIndexRoute,
}

const NiiDashboardRouteWithChildren = NiiDashboardRoute._addFileChildren(
  NiiDashboardRouteChildren,
)

interface OrganizationRouteChildren {
  OrganizationOrgIDRoute: typeof OrganizationOrgIDRoute
}

const OrganizationRouteChildren: OrganizationRouteChildren = {
  OrganizationOrgIDRoute: OrganizationOrgIDRoute,
}

const OrganizationRouteWithChildren = OrganizationRoute._addFileChildren(
  OrganizationRouteChildren,
)

interface SystemviewRouteChildren {
  SystemviewEntryIDRoute: typeof SystemviewEntryIDRoute
}

const SystemviewRouteChildren: SystemviewRouteChildren = {
  SystemviewEntryIDRoute: SystemviewEntryIDRoute,
}

const SystemviewRouteWithChildren = SystemviewRoute._addFileChildren(
  SystemviewRouteChildren,
)

interface LibraDashboardOrgIDRouteChildren {
  LibraDashboardOrgIDDashboardConfigIdRoute: typeof LibraDashboardOrgIDDashboardConfigIdRoute
}

const LibraDashboardOrgIDRouteChildren: LibraDashboardOrgIDRouteChildren = {
  LibraDashboardOrgIDDashboardConfigIdRoute:
    LibraDashboardOrgIDDashboardConfigIdRoute,
}

const LibraDashboardOrgIDRouteWithChildren =
  LibraDashboardOrgIDRoute._addFileChildren(LibraDashboardOrgIDRouteChildren)

interface PointCloudSiteIDRouteChildren {
  PointCloudSiteIDPointCloudOrSceneIDRoute: typeof PointCloudSiteIDPointCloudOrSceneIDRoute
  PointCloudSiteIDIndexRoute: typeof PointCloudSiteIDIndexRoute
}

const PointCloudSiteIDRouteChildren: PointCloudSiteIDRouteChildren = {
  PointCloudSiteIDPointCloudOrSceneIDRoute:
    PointCloudSiteIDPointCloudOrSceneIDRoute,
  PointCloudSiteIDIndexRoute: PointCloudSiteIDIndexRoute,
}

const PointCloudSiteIDRouteWithChildren =
  PointCloudSiteIDRoute._addFileChildren(PointCloudSiteIDRouteChildren)

interface OrganizationOrgIDSiteRouteChildren {
  OrganizationOrgIDSiteSiteIDRoute: typeof OrganizationOrgIDSiteSiteIDRoute
}

const OrganizationOrgIDSiteRouteChildren: OrganizationOrgIDSiteRouteChildren = {
  OrganizationOrgIDSiteSiteIDRoute: OrganizationOrgIDSiteSiteIDRoute,
}

const OrganizationOrgIDSiteRouteWithChildren =
  OrganizationOrgIDSiteRoute._addFileChildren(
    OrganizationOrgIDSiteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AvailabilityPlanningRouteRoute: AvailabilityPlanningRouteRouteWithChildren,
  ExplorerRouteRoute: ExplorerRouteRouteWithChildren,
  InboxRouteRoute: InboxRouteRouteWithChildren,
  PartsRouteRoute: PartsRouteRouteWithChildren,
  ShipsRouteRoute: ShipsRouteRouteWithChildren,
  ValueStoriesRouteRoute: ValueStoriesRouteRouteWithChildren,
  HealthCheckRoute: HealthCheckRoute,
  InventoryRoute: InventoryRoute,
  JobsRoute: JobsRoute,
  KestrelRoute: KestrelRouteWithChildren,
  LandingRoute: LandingRoute,
  LibraRoute: LibraRouteWithChildren,
  MigrationRoute: MigrationRoute,
  NiiDashboardRoute: NiiDashboardRouteWithChildren,
  OrganizationRoute: OrganizationRouteWithChildren,
  ReconstructionRoute: ReconstructionRoute,
  SystemviewRoute: SystemviewRouteWithChildren,
  AdminUsersRoute: AdminUsersRoute,
  AssemblyAssemblyIDRoute: AssemblyAssemblyIDRoute,
  BudgetingChar123SiteIDChar125Route: BudgetingChar123SiteIDChar125Route,
  DetailsEntryIDRoute: DetailsEntryIDRoute,
  DocumentUploadAssetIdRoute: DocumentUploadAssetIdRoute,
  DocumentsSiteIDRoute: DocumentsSiteIDRoute,
  DrilldownExplorationSiteIDRoute: DrilldownExplorationSiteIDRoute,
  EquipmentEquipmentIDRoute: EquipmentEquipmentIDRoute,
  ExtensionsOrgIDRoute: ExtensionsOrgIDRoute,
  FleetAnalysisSiteIDRoute: FleetAnalysisSiteIDRoute,
  FlightDataUploadSiteIDRoute: FlightDataUploadSiteIDRoute,
  HealthPlansChar123SiteIDChar125Route: HealthPlansChar123SiteIDChar125Route,
  HomeChar123SiteIDChar125Route: HomeChar123SiteIDChar125Route,
  ImportWizardSiteIDRoute: ImportWizardSiteIDRoute,
  InspectionsChar123SiteIDChar125Route: InspectionsChar123SiteIDChar125Route,
  JobSiteIDRoute: JobSiteIDRoute,
  LibraDashboardOrgIDRoute: LibraDashboardOrgIDRouteWithChildren,
  MaximoChar123SiteIDChar125Route: MaximoChar123SiteIDChar125Route,
  OverviewChar123SiteIDChar125Route: OverviewChar123SiteIDChar125Route,
  PointCloudSiteIDRoute: PointCloudSiteIDRouteWithChildren,
  SchedulingChar123SiteIDChar125Route: SchedulingChar123SiteIDChar125Route,
  SubAssemblySubAssemblyIDRoute: SubAssemblySubAssemblyIDRoute,
  SystemLensChar123SiteIDChar125Route: SystemLensChar123SiteIDChar125Route,
  UsersOrgIDRoute: UsersOrgIDRoute,
  WalkdownsChar123SiteIDChar125Route: WalkdownsChar123SiteIDChar125Route,
  WalkthroughChar123SiteIDChar125Route: WalkthroughChar123SiteIDChar125Route,
  WorkOrderWorkOrderIDRoute: WorkOrderWorkOrderIDRoute,
  Fallback_routeIndexRoute: Fallback_routeIndexRoute,
  LibraDashboardIndexRoute: LibraDashboardIndexRoute,
  ViewerIndexRoute: ViewerIndexRoute,
  deprecated_page_namesSiteViewSiteIDRoute:
    deprecated_page_namesSiteViewSiteIDRoute,
  AnomalyDetectionSiteIDDetectionConfigurationIdRoute:
    AnomalyDetectionSiteIDDetectionConfigurationIdRoute,
  AssetAssessmentSiteIDUnitIDRoute: AssetAssessmentSiteIDUnitIDRoute,
  AssetLensSiteIDUnitIDRoute: AssetLensSiteIDUnitIDRoute,
  AssetsSiteIDUnitIDRoute: AssetsSiteIDUnitIDRoute,
  CasesSiteIDCaseIDRoute: CasesSiteIDCaseIDRoute,
  OrganizationOrgIDSiteRoute: OrganizationOrgIDSiteRouteWithChildren,
  PrismOrgIDEntryIdRoute: PrismOrgIDEntryIdRoute,
  ProcessDataSiteIDDashboardIDRoute: ProcessDataSiteIDDashboardIDRoute,
  ProcessFlowsSiteIDDiagramIDRoute: ProcessFlowsSiteIDDiagramIDRoute,
  ReportingSiteIDReportIDRoute: ReportingSiteIDReportIDRoute,
  ReportingSiteIDNewRoute: ReportingSiteIDNewRoute,
  ViewerUnitIDConfigurationRoute: ViewerUnitIDConfigurationRoute,
  ViewerUnitIDInspectionRoute: ViewerUnitIDInspectionRoute,
  VirtualReportsSiteIDComponentIDRoute: VirtualReportsSiteIDComponentIDRoute,
  WalkdownsSiteIDWalkdownIdRoute: WalkdownsSiteIDWalkdownIdRoute,
  AlertsChar123SiteIDChar125IndexRoute: AlertsChar123SiteIDChar125IndexRoute,
  AnomalyDetectionSiteIDIndexRoute: AnomalyDetectionSiteIDIndexRoute,
  AssetAssessmentSiteIDIndexRoute: AssetAssessmentSiteIDIndexRoute,
  AssetsChar123SiteIDChar125IndexRoute: AssetsChar123SiteIDChar125IndexRoute,
  CasesChar123SiteIDChar125IndexRoute: CasesChar123SiteIDChar125IndexRoute,
  ProcessDataChar123SiteIDChar125IndexRoute:
    ProcessDataChar123SiteIDChar125IndexRoute,
  ProcessFlowsChar123SiteIDChar125IndexRoute:
    ProcessFlowsChar123SiteIDChar125IndexRoute,
  ReportingChar123SiteIDChar125IndexRoute:
    ReportingChar123SiteIDChar125IndexRoute,
  ViewerUnitIDIndexRoute: ViewerUnitIDIndexRoute,
  VirtualReportsChar123SiteIDChar125IndexRoute:
    VirtualReportsChar123SiteIDChar125IndexRoute,
  WalkdownsSiteIDIndexRoute: WalkdownsSiteIDIndexRoute,
  CasesSiteIDEditCaseIDRoute: CasesSiteIDEditCaseIDRoute,
  ProductionDashboardOrgIDSiteIDConfigIDRoute:
    ProductionDashboardOrgIDSiteIDConfigIDRoute,
  ProductionDashboardOrgIDSiteIDIndexRoute:
    ProductionDashboardOrgIDSiteIDIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
